import { DialogUtility } from '@syncfusion/ej2-react-popups';
// import { Oval } from 'react-loader-spinner'
import CallApi from "../apiConnect/CallApi";
import { APIBaseURL, LinkURL, GatewayURL, AttachURL, SupportURL } from '../apiConnect/config';
import { ReactSession } from 'react-client-session';
import { ToastUtility } from '@syncfusion/ej2-react-notifications';
import axios from "axios";
import CryptoJS from "crypto-js";
import loLanguage from '../oredesign/orelanguage.json';
import ShortUniqueId from 'short-unique-id';
import { v1 as uuidv1 } from 'uuid';
import { CDNPath } from '../apiConnect/config';
import { printerService } from '../addons/Bluetooth/PrinterServiceNew';
import { parse, stringify } from "@adobe/css-tools";
import ExcelJS from "exceljs";
import { saveAs } from "file-saver";
let refScrLocalVariables = { current: {} }, refDesignData = { current: {} }, refSterContols = { current: {} }, refdraftsave = { current: "" }, refExpdata = { current: "" }, refapprovereject = { current: "" };
let refGlobalThemeJSON = {};
let lbneedUATLocal = window.origin.includes("localhost:44466") === true && typeof process.env.REACT_APP_GW_URL === "string" && process.env.REACT_APP_GW_URL != "" ? true : false;
export function tcHlpFormatResponse(psDataArray) {
    try {
        return JSON.stringify(psDataArray, null, 2)
    }
    catch (err) {
        console.log("Error Occurred" + err)
        return
    }
};
//JSON to Tree Children Format Change
export function glbFunJsonToTree(psbusiness_tree) {
    let loBusinessTree = function (psbusiness_tree, root) {
        var r, o = {};
        psbusiness_tree.forEach(function (a) {
            a.children = o[a.id] && o[a.id].children;
            if (a.children === undefined) a.children = [];
            o[a.id] = a;
            if (a.parent === root) {
                r = a;
            } else {
                o[a.parent] = o[a.parent] || {};
                o[a.parent].children = o[a.parent].children || [];
                o[a.parent].children.push(a);
            }
        });
        return r;
    }(psbusiness_tree, null);
    return [loBusinessTree];
}
//JSON to Tree Children Format Change for Menu
export function glbFunJsonToMenuTree(psmenudata) {
    let loMenuData = function (psbusiness_tree, root) {
        var r, o = {};
        psmenudata.forEach(function (a) {
            a.items = o[a.id] && o[a.id].items;
            //if (a.items === undefined) a.items = [];
            o[a.id] = a;
            if (a.parent === root) {
                r = a;
            } else {
                o[a.parent] = o[a.parent] || {};
                o[a.parent].items = o[a.parent].items || [];
                o[a.parent].items.push(a);
            }
        });
        return r;
    }(psmenudata, null);
    return [loMenuData];
}
//JSON to Tree Children Format Change for DMS
export function glbFunJsonToTreeDMS(psbusiness_tree) {
    let loBusinessTree = function (psbusiness_tree, root) {
        var r, o = {};
        psbusiness_tree.forEach(function (a) {
            a.child = o[a.id] && o[a.id].child;
            if (a.child === undefined) a.child = [];
            o[a.id] = a;
            if (a.parent === root) {
                r = a;
            } else {
                o[a.parent] = o[a.parent] || {};
                o[a.parent].child = o[a.parent].child || [];
                o[a.parent].child.push(a);
            }
        });
        return r;
    }(psbusiness_tree, null);
    return [loBusinessTree];
}
//Random Color Generation
export function glbFunRandomColor() {
    let maxVal = 0xFFFFFF; // 16777215
    let randomNumber = Math.random() * maxVal;
    randomNumber = Math.floor(randomNumber);
    randomNumber = randomNumber.toString(16);
    let randColor = randomNumber.padStart(6, 0);
    return `#${randColor.toUpperCase()}`
}
//JSON to Lookup Acceptable Parameter Format Change
export function glbJSONToLookupFormat(psjson) {
    return JSON.stringify(psjson).split(',"').join("@").slice(1, -1).replace(/@/g, "~").replace(/"/g, "");
}


export function recordlog(psjson) {
    console.log(psjson, "logged");
}

export const showAlert = (message, type, acceptFunction) => {
    let toastObj;
    let title;
    switch (type) {
        case "warning":
            toastObj = ToastUtility.show(
                {
                    title: 'Warning',
                    cssClass: 'ostWarning',

                    content: message,
                    timeOut: 2000,
                    icon: 'far fa-exclamation-triangle',
                    position: { X: 'Right', Y: 'Top' },
                    showCloseButton: false,
                }
            );
            break;
        case "error":
            toastObj = ToastUtility.show({
                title: 'Error',
                cssClass: 'ostDanger',
                content: message,
                timeOut: 2000,
                icon: 'far fa-times',
                position: { X: 'Right', Y: 'Top' },
                showCloseButton: false,
            });
            break;
        case "info":
            toastObj = ToastUtility.show({
                title: 'Info',
                cssClass: 'ostInfo',
                content: message,
                timeOut: 2000,
                icon: 'far fa-info-circle',
                position: { X: 'Right', Y: 'Top' },
                showCloseButton: false,
            });
            break;
        case "success":
            toastObj = ToastUtility.show({
                title: 'Success',
                cssClass: 'ostSuccess',
                content: message,
                timeOut: 2000,
                icon: 'far fa-check',
                position: { X: 'Right', Y: 'Top' },
                showCloseButton: false,
            });
            break;
        case "success1":
            toastObj = ToastUtility.show({
                title: 'Success Test',
                content: message,
                timeOut: 2000,
                cssClass: 'ostSuccess',
                icon: 'far fa-check',
                position: { X: 'Right', Y: 'Top' },
                showCloseButton: false,
            });
            break;

        default:
            toastObj = ToastUtility.show(
                {
                    title: 'Information',
                    cssClass: 'ostInfo',
                    content: message,
                    timeOut: 2000,
                    icon: 'far fa-info-circle',
                    position: { X: 'Right', Y: 'Top' },
                    showCloseButton: false,
                }
            );
    }

};

export const CallConfirmDialog = (type, message, acceptFunction, rejectFunction) => {
    if (message === "" || message === undefined || message === null) {
        return
    }
    if (typeof message === "object" && message !== null) {
        let lsmessage = '';
        message.forEach((data) => {
            lsmessage += '<div class="text-left">' + data + '</div>';
        })
        message = lsmessage;
    }
    if (type === "warning" && typeof message === "object" && message !== null) {
        let lsmessage = '';
        message.forEach((data) => {
            lsmessage += '<div class="text-left">' + data + '</div>';
        })
        message = lsmessage;
    }
    let dialogobj;
    const fnokClick = () => {
        // dialogobj.hide()
        // Edit - 29-DEC-25 - hide replaced by destroy - issue Scenario - this dialog called in static page in button event and also called screen close event when the screen closed and this dialog shows and clicking ok button the closed screen show again;
        // Ticket Ref - SWENGG - 457 - After closing a static page through direct code the page is opening again - MIOT
        dialogobj.destroy()
        if (acceptFunction !== undefined) {
            acceptFunction()
        }
    }
    const fnCancelClick = () => {
        dialogobj.hide()
        if (rejectFunction !== undefined) {
            rejectFunction()
        }
    }
    switch (type) {
        case "delete":
            dialogobj = DialogUtility.confirm({
                title: '<div><div class="alertDialoge"  ><span class="alert-icon-big alert-blob  tag-badge-light-danger"><i class="far fa-file-times "></i></span><h1 class="alert-c-title">Delete Confirmation</h1></div></div>',
                content: '<div><div class="alertContent"  >' + message + '</div></div>',
                width: '400px', animationSettings: { effect: 'None' }, position: { X: 'center', Y: 'center' },
                okButton: { cssClass: 'btn-danger min-width-btn m-0', icon: 'far fa-check', text: 'Delete', click: fnokClick },
                cancelButton: { cssClass: 'btn-light min-width-btn m-0', icon: 'far fa-times', click: rejectFunction }
            });
            break;
        case "warning":
            dialogobj = DialogUtility.alert({
                title: '<div><div class="alertDialoge"  ><span class="alert-icon-big alert-blob  tag-badge-light-warning"><i class="far fa-exclamation-triangle "></i></span><h1 class="alert-c-title">Critical Confirmation</h1></div></div>',
                content: '<div><div class="alertContent"  >' + message + '</div></div>',
                width: '400px', animationSettings: { effect: 'None' }, position: { X: 'center', Y: 'center' },
                okButton: { cssClass: 'btn-warning min-width-btn m-0', icon: 'far fa-check', text: 'OK', click: fnokClick },
            });
            break;
        case "savevalid":
            dialogobj = DialogUtility.alert({
                title: '<div><div class="alertDialoge"><span class="alert-icon-big alert-blob  tag-badge-light-danger"><i class="far fa-info-circle"></i></span><h1 class="alert-c-title">Please Fill Mandatory Fields</h1></div></div>',
                content: '<div><div class="alertContent font-weight-600">' + message + '</div></div>',
                width: '400px', animationSettings: { effect: 'None' }, position: { X: 'center', Y: 'center' },
                okButton: { cssClass: 'btn-danger min-width-btn m-0', icon: 'far fa-check', text: 'OK', click: fnokClick },
            });
            break;
        case "info":
            dialogobj = DialogUtility.alert({

                title: '<div><div class="alertDialoge"  ><span class="alert-icon-big alert-blob  tag-badge-light-info"><i class="far fa-info-circle"></i></span><h1 class="alert-c-title">Information</h1></div></div>',
                content: '<div><div class="alertContent"  >' + message + '</div></div>',
                width: '400px', animationSettings: { effect: 'None' }, position: { X: 'center', Y: 'center' },
                okButton: { cssClass: 'btn-info min-width-btn m-0', icon: 'far fa-check', text: 'OK', click: fnokClick },

            });
            break;
        case "success":
            dialogobj = DialogUtility.alert({
                title: '<div><div class="alertDialoge"  ><span class="alert-icon-big alert-blob  tag-badge-light-success"><i class="far fa-thumbs-up "></i></span><h1 class="alert-c-title">Success</h1></div></div>',
                content: '<div><div class="alertContent"  >' + message + '</div></div>',
                width: '400px', animationSettings: { effect: 'None' }, position: { X: 'center', Y: 'center' },
                okButton: { cssClass: 'btn-success min-width-btn m-0', icon: 'far fa-check', text: 'OK', click: fnokClick },
            });
            break;
        case "confirm":
            dialogobj = DialogUtility.confirm({
                title: '<div><div class="alertDialoge"  ><span class="alert-icon-big alert-blob  tag-badge-light-info"><i class="far fa-exclamation-circle mx-2"></i></span><h1 class="alert-c-title">Confirmation</h1></div></div>',
                content: '<div><div class="alertContent" >' + message + '</div></div>',
                width: '400px', animationSettings: { effect: 'None', delay: 0, duration: 400 }, position: { X: 'center', Y: 'center' },
                okButton: { cssClass: 'btn-info min-width-btn m-0', icon: 'far fa-check', text: 'Yes', click: fnokClick },
                cancelButton: { cssClass: 'btn-light min-width-btn m-0', icon: 'far fa-times', text: 'No', click: fnCancelClick },

            });
            break;
        default:
            dialogobj = DialogUtility.alert({
                title: '<div><div class="alertDialoge"  ><span class="alert-icon-big alert-blob  tag-badge-light-success"><i class="far fa-thumbs-up "></i></span><h1 class="alert-c-title">Success</h1></div></div>',
                content: '<div><div class="alertContent"  >' + message + '</div></div>',
                width: '400px', animationSettings: { effect: 'None' }, position: { X: 'center', Y: 'center' },
                okButton: { cssClass: 'btn-success min-width-btn m-0', icon: 'far fa-check', text: 'OK', click: fnokClick },
            });

    }

//accept.bind(this)

/*
 this.confirmOkAction.bind(this)  
 this.confirmCancelAction.bind(this)
   confirmDialog({
        message: message,
        header: header,
        icon: icon,
        accept: accept,
        reject: reject,
        acceptClassName: 'p-button-danger',

    });
 */}


export const GetMaxFromJSON = (poJsOn, psField) => {
    var maxValue = 0;
    for (let psField in poJsOn) {
        if (poJsOn[psField] > maxValue) {
            maxValue = poJsOn[psField];
        }
    }
}
export const glbMandatoryValid = (pnvalue, psprops) => {
    if (psprops !== undefined && psprops.required === true && (psprops.hasOwnProperty('hide') === false || (psprops.hasOwnProperty('hide') === true && psprops.hide === false || psprops.hide === "false" || psprops.hide === ""))) {
        // ui455 0 Condition Added Against Grid Validations
        if (typeof (pnvalue) !== "object") {
            if (pnvalue === "" || pnvalue === null || pnvalue === undefined || pnvalue === false/* || pnvalue === 0 || pnvalue === "0" */) {
                return false
            }
            else {
                return true;
            }
        }
        else {
            if (pnvalue === null || pnvalue === undefined || pnvalue.length === 0) {
                return false
            }
            else {
                return true;
            }
        }
    }
    return true;
}
export const glbGetLocalStorage = (pskey) => {
    let loglbalref = window.glbref;
    if (loglbalref !== undefined) {
        return window.glbref.GetContextStorage(pskey);
    }
    let lscurdomain = ReactSession.get("currenttpdomain");
    let loencrypt = ReactSession.get(lscurdomain + '-' + "xyghd");
    try {
        loencrypt = glDecrypt(loencrypt).toString();
        if (loencrypt !== "") {
            loencrypt = JSON.parse(loencrypt);
            if (loencrypt[pskey]) {
                return loencrypt[pskey];
            }
        }
    }
    catch (err) {

    }
    let lskey = lscurdomain + '-' + pskey
    let losessval = ReactSession.get(lskey)
    if (pskey === "xyghd") {
        losessval = glDecrypt(losessval);
    }
    return getDefaultValue(losessval, "S")

    /*   let lovUserData = window.localStorage.getItem(pskey);
      if (lovUserData !== null && lovUserData !== undefined) {
          lovUserData = JSON.parse(lovUserData);
          return lovUserData;
      }
      return {}; */
}
export const glbSetLocalStorage = (pskey, pskeyval, psskey = "", pssval = "") => {
    let loglbalref = window.glbref;
    if (loglbalref !== undefined) {
        glbSetContextStorage(pskey, pskeyval, loglbalref);
        return
    }
    if (pskey === "clearsession") {
        window.localStorage.clear();
    }
    else {
        let lscurdomain = ReactSession.get("currenttpdomain");
        try {
            ReactSession.set(lscurdomain + '-' + pskey, pskeyval);
        }
        catch (err) {
            console.log(err, pskey, pskeyval);
            // showAlert("Setting the value of '__react_session__' exceeded the quota", 'error');
        }
    }
    //    window.localStorage.setItem(pskey, JSON.stringify(pskeyval));
}
const glbSetContextStorage = (pskey, pskeyval, loglbalref) => {
    try {
        if (pskey === "clearsession") {
            loglbalref.SetContextStorageAll("localstorage", {});
            window.localStorage.clear();
        }
        else {
            loglbalref.SetContextStorage(pskey, pskeyval);
        }
    }
    catch (err) {
        console.log(err, pskey, pskeyval);
        // showAlert("Setting the value of '__react_session__' exceeded the quota", 'error');
    }
}

export const glbGetCurrentDomain = () => {
    return ReactSession.get("currenttpdomain");
}
export const glbSetCurrentDomain = async (lodngwinfpo) => {
    let lsEnvDomain = window.location.host;
    if (lsEnvDomain.includes("localhost:44466") || lsEnvDomain.includes("182.20.10.101:44466") || lsEnvDomain.includes("182.20.10.212:44466") || lsEnvDomain.includes("182.20.10.47:44466")) {
        lsEnvDomain = "dev.oreapps.com";
        // lsEnvDomain = "iplshaw.sterloapp.com";
        // lsEnvDomain = "gknmh.sterloapp.com";
        // lsEnvDomain = "gcedms.sterloapp.com";
        // lsEnvDomain = "equaliser.lntecc.com";
        // lsEnvDomain = "bansal.sterloapp.com";
        // lsEnvDomain = "firststep.tactivesoft.com";
        // lsEnvDomain = "erp.amarinfraprojects.co.in";        
        // lsEnvDomain = "20.204.200.73";//http://20.204.206.26/    
        /*let loconfig = glbGetLocalStorage("config");
        if (loconfig !== undefined && loconfig !== null) {
            if (loconfig.hasOwnProperty("domainurl")) {
                lsEnvDomain = loconfig.domainurl;
            }
        }*/
    }
    if (lbneedUATLocal) {
        lsEnvDomain = process.env.REACT_APP_DOMAIN_URL;
    }
    if (typeof lodngwinfpo === "object" && lodngwinfpo !== null && lodngwinfpo.dn !== undefined) {
        lsEnvDomain = lodngwinfpo.dn;
    }
    lsEnvDomain = lsEnvDomain.replace(/:/g, "!");
    let lsEnvHost = window.location.href;
    if (lsEnvHost.includes("newdesign")) {
        lsEnvHost = window.location.origin;
    }
    ReactSession.set("currenttpdomain", lsEnvDomain);
    ReactSession.set("currenthref", lsEnvHost);
}
const glbUpdateManifest = async (poconfig, lsEnvDomain) => {
    if (window.origin.includes("localhost:44466") || window.origin.includes("182.20.10.101:44466") || window.origin.includes("182.20.10.212:44466")) {
        lsEnvDomain = lsEnvDomain.replaceAll(".", "_").toLowerCase();
        // lsEnvDomain="dev_oreapps._com"
        let lsmanifestpath = poconfig.cdnpath + "/client/" + lsEnvDomain + "/favicon.ico?v=" + process.env.REACT_APP_VERSION;
        fetch(lsmanifestpath, { method: 'HEAD' })
            .then((response) => {
                if (response.ok) {
                    // console.log('File exists.');
                    const link1 = document.getElementById("icon-favicon");
                    if (link1) {
                        link1.href = lsmanifestpath;
                        document.getElementById("icon-favicon").href = poconfig.cdnpath + "/client/" + lsEnvDomain + "/favicon.ico?v=" + process.env.REACT_APP_VERSION;
                    }
                }
            })
            .catch((error) => {
                console.log('Error:', error);
            });
    }
}
export const glbChangeMode = (pstheme, pnupdate) => {
    if (pstheme === "") {
        let loUserconfig = glbGetLocalStorage('ssUserConfig');
        if (loUserconfig !== undefined && loUserconfig !== null && loUserconfig !== "") {
            pstheme = loUserconfig.defvalues.theme;

        }
    }
    if (pstheme === "dark") {
        // document.getElementsByTagName("html")[0].setAttribute("data-theme", "dark");
        // glbSetLocalStorage("theme", "dark");
    }
    else {
        // document.getElementsByTagName("html")[0].setAttribute("data-theme", "");
        // glbSetLocalStorage("theme", "light");
    }
    let lnglobaltheme = glbGetLocalStorage("globaltheme");
    if (!(lnglobaltheme !== "" && lnglobaltheme !== undefined && lnglobaltheme !== null)) {
        let lscurrenttpdomain = ReactSession.get("currenttpdomain");
        if (lscurrenttpdomain === "dreg.sterloapp.com" ||
            lscurrenttpdomain === "dreg.sterloapp.ae" ||
            lscurrenttpdomain === "cmcvellore.sterloapp.com" ||
            lscurrenttpdomain === "prebuilt.sterloapp.com" ||
            lscurrenttpdomain === "urc.sterloapp.com" ||
            lscurrenttpdomain === "quality.sterloapp.com" ||
            lscurrenttpdomain === "aaacrg.sterloapp.com" ||
            lscurrenttpdomain === "ehsconsultants.sterloapp.com" ||
            lscurrenttpdomain === "20.204.200.73" ||
            lscurrenttpdomain === "upmrcl.tactiveplus.com") {
            if (pnupdate === true) {
                // document.getElementsByTagName("html")[0].setAttribute("data-theme", "dark bluedark");
            }
            else {
                document.getElementsByTagName("html")[0].setAttribute("data-theme", "bluedark");
            }
        }
    }
    // if (pnupdate === 1) {
    //     let lovUserData = glbGetLocalStorage('REACTIVE_APP_STATE');
    //     lovUserData.theme = pstheme;
    //     glbSetLocalStorage('REACTIVE_APP_STATE', lovUserData);
    // }
}

export function getDefaultValue(poValue, psType) {
    if (psType === "N") {
        if (poValue === '' || poValue === null || poValue === undefined) { return 0; } else { return poValue; }
    }
    else if (psType === "S" || psType === "D") {
        if (poValue === '' || poValue === null || poValue === undefined) { return ""; } else { return poValue; }
    }
    // else if (psType === "D") {
    //     if (poValue === '' || poValue === null || poValue === undefined) { return ""; } else { return poValue; }
    // }
}

export function GetLoadingSpinner(props) {
    return (
        <>
            <div className='d-none' >
                {/* <ColorRing
                    visible={props.showUI}
                    height="120"
                    width="120"
                    ariaLabel="blocks-loading"
                    wrapperStyle={{}}
                    wrapperClass="blocks-wrapper"
                    colors={['#388ed4','#388ed4','#388ed4','#388ed4','#388ed4']}
                /> */}
                {/* <Oval
                    height={80}
                    width={80}
                    color="#14274e"
                    wrapperStyle={{}}
                    wrapperClass=""
                    visible={true}
                    ariaLabel='oval-loading'
                    secondaryColor="#a9b2c5"
                    strokeWidth={2}
                    strokeWidthSecondary={2}

                /> */}
            </div>
        </>
    )
};

export async function glbSwitchOrgEnv(pnorgid, pnenvtype) {
    let loAPIResult = await CallApi({ method: "post", lookup: "Authentication/ChangeOrganization", params: { "orgid": pnorgid, "envtype": pnenvtype }, toa: "r", });
    if (loAPIResult.status === true) {
        let loResultData = loAPIResult.data;
        let lsrefreshtoken = loResultData.RefreshToken;
        let lsaccesstoken = loResultData.AccessToken;
        let lsexpires = loResultData.Expires;
        let lslogkey = loResultData.LogToken;
        glbSetLocalStorage("refreshtoken", lsrefreshtoken);
        glbSetLocalStorage("accesstoken", lsaccesstoken);
        glbSetLocalStorage("expires", lsexpires);
        glbSetLocalStorage("logkey", lslogkey);
        glbSetLocalStorage("envtype", pnenvtype);
        // console.log("Session");
        // console.log(JSON.stringify(ReactSession));
    }
    else {
        showAlert(loAPIResult.errmsg, 'error');
    }
}

/*export function glbGetDomainName() {
    let lsEnvDomainHost = window.location.host;
    let lsEnvDomain = window.location.host;

    if (lsEnvDomain.includes("localhost:44466")) {
        lsEnvDomain = "lntdev.oreapps.com";
        // lsEnvDomain = "52.140.120.27:81";
    }
    lsEnvDomainHost = lsEnvDomain;
    lsEnvDomain = lsEnvDomain.replace(/:/g, "!");
    return lsEnvDomain;
}*/
export async function fnlDocumentNoCreate(psDocType, pnmode, psdocinfo, podocvalues, pstype) {
    let lsDocType = psDocType;
    let lspara = { "psDocType": lsDocType, "pnmode": pnmode }
    // let lousercode = await glbFunLookupProcess("rt/6/-1/D001", lspara);
    let lsaddInfo = {};
    if (psdocinfo != undefined && psdocinfo.disformat !== null && psdocinfo.disformat !== '' && psdocinfo.disformat.includes('projcode')) {
        if (podocvalues !== undefined) {
            lsaddInfo.projcode = podocvalues.projcode;
        }
    }
    if (pstype === "task") {
        psDocType = { "doctype": psDocType };
        psDocType = JSON.stringify(psDocType);
    }
    let loaddInfo = [];
    loaddInfo.push(lsaddInfo);
    loaddInfo = JSON.stringify(loaddInfo);
    // '{"params":{"projcode":"1234","disc":"CIVIL"}}';
    let loResponse = await CallApi({ method: "get", lookup: "dpcrud/GetDocumentNo", "params": "docID=" + psDocType + "&mode=" + pnmode + "&lparams=" + loaddInfo, toa: "d" });
    return await loResponse.data;
    // let lousercode = loResponse.data;
    // return await lousercode[0].docnumber;
    // console.log(lousercode[0].docnumber);
}
export async function fnlScreenDocumentNoCreate(psDocType) {
    let lspara = { "psdocid": psDocType };
    // let lousercode = await glbFunLookupProcess("rt/6/-1/D001", lspara);
    let loResponse = await CallApi({ method: "get", lookup: "dpcrud/rt", params: { id: 6, ver: -1, alias: "D002", lparams: lspara }, toa: "d" });
    return await loResponse;
    // [0].doctype;
    // console.log(lousercode[0].docnumber);
}
export async function fnlNewDocumentNoCreate(podocjson, pnmode, pstype) {
    try {
        let lodocjson = podocjson;
        if (typeof lodocjson !== "object") {
            lodocjson = JSON.parse(podocjson);
        }
        let lsdisformat = '';
        let locontrolid = [];
        if (lodocjson.type === "DIRECT") {
            if (lodocjson.prefix !== "" && lodocjson.prefix !== undefined && lodocjson.prefix !== null) {
                lsdisformat += lodocjson.prefix;
            }
        }
        lsdisformat += "<DOC>";
        if (lodocjson.suffix !== "" && lodocjson.suffix !== undefined && lodocjson.suffix !== null) {
            lsdisformat += lodocjson.suffix;
        }
        let lsDocType = "", psDocType = "";
        let lspara = { "psDocType": lsDocType, "pnmode": pnmode }
        let lsaddInfo = {};
        if (pstype === "task") {
            psDocType = { "doctype": psDocType };
        }
        else {
            psDocType = { "doctype": lodocjson.reseton, "reseton": lodocjson.reseton, "length": "4", "disformat": lsdisformat };
        }
        psDocType = JSON.stringify(psDocType);
        let loaddInfo = [];
        loaddInfo.push(lsaddInfo);
        loaddInfo = JSON.stringify(loaddInfo);
        // '{"params":{"projcode":"1234","disc":"CIVIL"}}';
        let loResponse = await CallApi({ method: "get", lookup: "dpcrud/GetDocumentNo", "params": "docID=" + psDocType + "&mode=" + pnmode + "&lparams=" + loaddInfo, toa: "d" });
        loResponse.locontrolid = locontrolid;
        return await loResponse;
    }
    catch (err) {
        showAlert(err.message, 'info');
        return { "status": false };
    }
}
export async function fnlNewDocumentNoCreateOld(psDocType, pnmode, pstype) {
    let lsDocType = psDocType;
    let lspara = { "psDocType": lsDocType, "pnmode": pnmode }
    // let lousercode = await glbFunLookupProcess("rt/6/-1/D001", lspara);
    let lsaddInfo = {};
    // if (psdocinfo != undefined && psdocinfo.disformat !== null && psdocinfo.disformat !== '' && psdocinfo.disformat.includes('projcode')) {
    //     if (podocvalues !== undefined) {
    //         lsaddInfo.projcode = podocvalues.projcode;
    //     }
    // }
    if (pstype === "task") {
        psDocType = { "doctype": psDocType };
        psDocType = JSON.stringify(psDocType);
    }
    let loaddInfo = [];
    loaddInfo.push(lsaddInfo);
    loaddInfo = JSON.stringify(loaddInfo);
    // '{"params":{"projcode":"1234","disc":"CIVIL"}}';
    let loResponse = await CallApi({ method: "get", lookup: "dpcrud/GetDocumentNo", "params": "docID=" + psDocType + "&mode=" + pnmode + "&lparams=" + loaddInfo, toa: "d" });
    return await loResponse.data;
}
export async function glbMailMerge(pndesignslno) {
    let baseUrl = APIBaseURL + 'v1/Word/MergeDesignDocPDF?designid=' + pndesignslno + '&jsondata=1';
    let httpRequest = new XMLHttpRequest();
    httpRequest.open('GET', baseUrl, true);
    httpRequest.setRequestHeader('Content-Type', 'application/json;charset=UTF-8');
    httpRequest.onreadystatechange = () => {
        if (httpRequest.readyState === 4) {
            if (httpRequest.status === 200 || httpRequest.status === 304) {
                return httpRequest.responseText;
            }
        }
    };
    httpRequest.send();
}
export async function glbPrint(serialno, designid) {
    let lsAccessToken = glbGetLocalStorage("accesstoken");
    let loHeader = { "Content-Type": "application/json", "Authorization": "Bearer " + lsAccessToken, "toa": "s", "skpencypt": true, "skpdecypt": true };
    let lsGatewayURL = GatewayURL;
    let lsSupportURL = SupportURL;
    let lslookupparam = 'Word/MergeDesignDocPdf?designid=' + designid + '&pnserialno=' + serialno;
    let lsbody = { "designid": designid, "pnserialno": serialno };
    let loconfig = glbGetLocalStorage("config");
    if (loconfig !== undefined && loconfig !== null) {
        if (loconfig.hasOwnProperty("gatewayurl")) {
            lsGatewayURL = loconfig.gatewayurl;
        }
        if (loconfig.hasOwnProperty("supporturl")) {
            lsSupportURL = loconfig.supporturl;
        }
    }
    lsbody.acstok = lsAccessToken;
    lsbody.gturl = lsGatewayURL;
    let loResponse = await axios.post(lsGatewayURL + lsSupportURL + lslookupparam, JSON.stringify(lsbody), { headers: loHeader });
    if (loResponse.status === true || loResponse.status === 200) {
        return loResponse.data;
    } else {
        showAlert("Failed to fetch print design: " + loResponse.statusText, 'error');
    }
}
export async function glbPrintDesignOpen(serialno, designid) { //Direct print dialog logic handled
    await glbPrint(serialno, designid).then((response) => {
        const byteCharacters = atob(response);
        const byteArrays = [];
        for (let offset = 0; offset < byteCharacters.length; offset += 512) {
            const slice = byteCharacters.slice(offset, offset + 512);
            const byteNumbers = new Array(slice.length);
            for (let i = 0; i < slice.length; i++) {
                byteNumbers[i] = slice.charCodeAt(i);
            }
            const byteArray = new Uint8Array(byteNumbers);
            byteArrays.push(byteArray);
        }
        let blob = new Blob(byteArrays, { type: "application/pdf" });
        let blobUrl = URL.createObjectURL(blob);
        let Iframe = document.createElement('iframe')
        Iframe.id = 'printIframe';
        Iframe.style.display = 'none';
        Iframe.src = blobUrl
        document.body.appendChild(Iframe);
        const cleanup = () => {
            URL.revokeObjectURL(blobUrl);
            document.getElementById('printIframe')?.remove();
            window.removeEventListener('afterprint', cleanup);
        };
        window.addEventListener('afterprint', cleanup);
        Iframe.onload = () => {
            Iframe.contentWindow.focus();
            Iframe.contentWindow.print(); // Trigger the print dialog                        
            // setTimeout(() => cleanup(), 5000);
        };
    }).catch((error) => {
        console.error("Error printing design:", error);
        showAlert("Error printing design: " + error.message, 'error');
    });
}
export async function fnLoadRights(psrole) {
    let loRightsData = await CallApi({ method: "get", lookup: "dpcrud/rt", params: { id: 10, ver: -1, alias: "2YW946CoWi", lparams: { "pnRole": psrole } }, toa: 'u' });
    let lodata = [];
    if (loRightsData.status === true) {
        lodata = loRightsData.data;
        if (lodata !== null && lodata.length > 0) {
            glbSetLocalStorage("rights", lodata[0].rightdet);
        }
    } else {
        glbSetLocalStorage("rights", []);
    }
    return lodata
}

export const IsAllowed = (psvalue) => {
    let lnresult = [];
    let lorights = [];
    let lorightsdata = glbGetLocalStorage("rights");
    let louserdata = glbGetLocalStorage("ssUserData");
    let lnRole = louserdata.rolecode;
    if (lnRole === "10" || lnRole === 10) {
        lnresult = 'a,e,d,v';
    } else if (psvalue === 1003 || psvalue === '1003') {
        if (lorightsdata !== null && lorightsdata !== undefined && lorightsdata.length > 0) {
            let loFinalArray = [];
            let loData = JSON.parse(lorightsdata);
            let lofinaldata = loData.filter((e) => { return e.fpid === 1003 && e.pgrp === '7' });
            if (lofinaldata.length > 0) {
                let loFltDesgLib = lofinaldata.filter(r => r.access === true || r.add === true || r.edit === true || r.delete === true);
                if (loFltDesgLib.length > 0) {
                    loFltDesgLib.forEach((e) => {
                        loFinalArray.push({ "fid": e.fid, "nature": e.nat, "access": e.access, "add": e.add, "edit": e.edit, "delete": e.delete })
                    })
                }
            }
            lnresult = loFinalArray;
        }
    } else {
        if (lorightsdata !== null && lorightsdata !== undefined) {
            if (lorightsdata.length > 0) {
                lorights = JSON.parse(lorightsdata);
            }
            if (lorights.length > 0) {
                let lofinaldata = lorights.filter((e) => { return e.fid === psvalue });
                if (lofinaldata.length > 0) {
                    if (lofinaldata[0].add === true) {
                        lnresult.push('a')
                    }
                    if (lofinaldata[0].edit === true) {
                        lnresult.push('e')
                    }
                    if (lofinaldata[0].delete === true) {
                        lnresult.push('d')
                    }
                    if (lofinaldata[0].access === true || lnresult.length > 0) {
                        lnresult.push('v')
                    }
                    lnresult = lnresult.join(',');
                }
                // console.log(lnresult, 'rights1');
                return lnresult;

            }
        }
    }
    // console.log(lnresult, 'rights');
    return lnresult;
}
export const glbGetConfig = async (lodngwinfpo) => {
    try {
        console.log(process.env.PUBLIC_URL);
        await glbSetCurrentDomain(lodngwinfpo);
        let lsAPIBaseURL = APIBaseURL;
        try {
            if (window.origin.includes("localhost:44466") === false && process.env.PUBLIC_URL !== undefined && process.env.PUBLIC_URL !== "" && process.env.PUBLIC_URL !== null) {
                lsAPIBaseURL = window.origin + "/" + process.env.PUBLIC_URL + '/api/';
                console.log(lsAPIBaseURL);
            }
        }
        catch (err) {
            console.log(err, "PUBLIC_URL error");
        }
        if (lbneedUATLocal) {
            let loconfig = { "gatewayurl": "", "authbaseurl": "api/v1/aut/", "taskurl": "api/v1/wfp/", "crudurl": "api/v1/dcr/", "attachurl": "api/v1/att/", "supporturl": "api/v1/sup/", "dasurl": "api/v1/das/", "langpref": false, "linkrurl": "https://localhost:44374/api/", "multisession": false, "hostname": "opucore-7bb8867678-7lbwp" };
            loconfig.gatewayurl = process.env.REACT_APP_GW_URL;
            loconfig.cdnpath = process.env.REACT_APP_CDN_PATH;
            await glbSetLocalStorage("config", loconfig);
        }
        else {
            var request = new XMLHttpRequest();
            await request.open('GET', lsAPIBaseURL + 'GetConfig', false);
            await request.send(null);
            if (request.status === 200) {
                let loResult = JSON.parse(request.responseText);
                if (typeof lodngwinfpo === "object" && lodngwinfpo !== null && lodngwinfpo.gw !== undefined) {
                    loResult.gatewayurl = lodngwinfpo.gw;
                }
                await glbSetLocalStorage("config", loResult);
                // let lsEnvDomain = ReactSession.get("currenttpdomain");
                // await glbUpdateManifest(loResult, lsEnvDomain);
            }
        }
    }
    catch (err) {
        console.log(err);
        glbSetLocalStorage("config", { cdnpath: CDNPath });
    }
}
export const glbGetServerDateTime = async () => {
    try {
        let lsAPIBaseURL = APIBaseURL;
        try {
            if (window.origin.includes("localhost:44466") === false && process.env.PUBLIC_URL !== undefined && process.env.PUBLIC_URL !== "" && process.env.PUBLIC_URL !== null) {
                lsAPIBaseURL = window.origin + "/" + process.env.PUBLIC_URL + '/api/';
                console.log(lsAPIBaseURL);
            }
        }
        catch (err) {
            console.log(err, "PUBLIC_URL error");
        }
        var request = new XMLHttpRequest();
        await request.open('GET', lsAPIBaseURL + 'GetDateTime', false);
        await request.send(null);
        if (request.status === 200) {
            await glbSetLocalStorage("serdate", request.responseText);
        }
    }
    catch (err) {
        console.log(err);
    }
}
export const glbGetServerDateTimeZone = async () => {
    try {
        let lsAPIBaseURL = APIBaseURL;
        try {
            if (window.origin.includes("localhost:44466") === false && process.env.PUBLIC_URL !== undefined && process.env.PUBLIC_URL !== "" && process.env.PUBLIC_URL !== null) {
                lsAPIBaseURL = window.origin + "/" + process.env.PUBLIC_URL + '/api/';
                console.log(lsAPIBaseURL);
            }
        }
        catch (err) {
            console.log(err, "PUBLIC_URL error");
        }
        let lstimezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
        // lstimezone = 'Asia/Calcutta';
        var request = new XMLHttpRequest();
        await request.open('GET', lsAPIBaseURL + 'GetDateTimeZone?pstimezone=' + lstimezone, false);
        await request.send(null);
        if (request.status === 200) {
            if (glbCheckValidDate(request.responseText)) {
                await glbSetLocalStorage("serdatezone", request.responseText);
            }
        }
    }
    catch (err) {
        console.log(err);
    }
}
export const glbRemoveSyncfusionTrial = () => {
    if (document.getElementById('__react-alert__')) {
        if (document.getElementById('__react-alert__').previousSibling.id !== "root") {
            document.getElementById('__react-alert__').previousSibling.remove();
        }
    }
}

export async function getGeoLocation() {
    try {
        var jsonlocation = {};
        if (!navigator.geolocation) {
            showAlert('Geolocation is not supported by your browser', 'warning');
        } else {
            // navigator.geolocation.getCurrentPosition((position) => {
            //     jsonlocation["lati"] = (position.coords.latitude);
            //     jsonlocation["long"] = (position.coords.longitude);
            // })
            const position = await new Promise((resolve, reject) => {
                navigator.geolocation.getCurrentPosition(resolve, reject);
            });
            jsonlocation["lati"] = position.coords.latitude;
            jsonlocation["long"] = position.coords.longitude;
        }
        return jsonlocation;
    } catch (error) {
        console.error(error);
        return jsonlocation;
    }
}
export async function glbInsertLinks(lsbody) {
    let loauthHeader = { "Authorization": "Basic oreplususer:QH8*34^A@0!S" }
    let loResponse = {};
    await axios.post(LinkURL + "Link/InsertLinks", lsbody, { headers: loauthHeader }).then((res) => {
        loResponse.status = true;
        loResponse.data = res.data;
        // showAlert("Shared Successfully !!!", 'success')       
    }).catch(error => {
        loResponse.status = false;
        loResponse.data = error.response !== undefined && error.response.data !== undefined ? error.response.data : error.message;
    });
    return loResponse;
}
export async function glbCheckLinks(lnlinkid) {
    let loauthHeader = { "Authorization": "Basic oreplususer:QH8*34^A@0!S" }
    let loResponse = {};
    await axios.get(LinkURL + "Link/CheckLinks?linkid=" + lnlinkid, { headers: loauthHeader }).then((res) => {
        loResponse.status = true;
        loResponse.data = res.data;
    }).catch(error => {
        loResponse.status = false;
        loResponse.data = error.response !== undefined && error.response.data !== undefined ? error.response.data : error.message;
    });
    return loResponse;
}
export const glbgetNodeTree = (node, controlsList) => {
    if (node.hasChildNodes()) {
        var children = [];
        for (var j = 0; j < node.childNodes.length; j++) {
            //let lsctrlName = '', lsctrlCode = '';
            if (node.childNodes[j].hasChildNodes() && node.childNodes[j].childNodes[0].hasChildNodes() && node.childNodes[j].childNodes[0].childNodes[0].hasChildNodes()) {
                let locontrol = controlsList.filter(x => x.ctrltype == node.childNodes[j].childNodes[0].childNodes[0].getAttribute('ctrlcode'));
                if (locontrol.length > 0) {
                    //lsctrlName = locontrol[0].content;
                    //lsctrlCode = locontrol[0].ctrltype;
                    node.childNodes[j].ctrlName = locontrol[0].content;
                    node.childNodes[j].ctrlcode = locontrol[0].ctrltype;
                }
            }
            children.push(glbgetNodeTree(node.childNodes[j], controlsList));
        }
        let lsctrlName = '', lsctrlCode = '';
        if (node.childNodes[0].hasChildNodes() && node.childNodes[0].childNodes[0].hasChildNodes() && node.childNodes[0].childNodes[0].childNodes[0].hasChildNodes()) {
            let locontrol = controlsList.filter(x => x.ctrltype == node.childNodes[0].childNodes[0].childNodes[0].getAttribute('ctrlcode'));
            if (locontrol.length > 0) {
                //lsctrlName = locontrol[0].content;
                //lsctrlCode = locontrol[0].ctrltype;
                lsctrlName = locontrol[0].content;
                lsctrlCode = locontrol[0].ctrltype;
            }
        }
        else {
            lsctrlName = "";
            lsctrlCode = (node.attributes.ctrlcode !== undefined) ? node.attributes.ctrlcode.textContent : '';
        }
        return {
            nodeName: node.nodeName,
            parentName: node.parentNode.nodeName,
            children: children,
            content: node.innerText || "",
            id: (node.attributes.id !== undefined) ? node.attributes.id.textContent : '',
            class: (node.attributes.class !== undefined) ? node.attributes.class.textContent : '',
            ctrlcode: (node.attributes.ctrlcode !== undefined) ? node.attributes.ctrlcode.textContent : '',
            style: (node.attributes.style !== undefined) ? node.attributes.style.textContent : '',
            ctrlName: lsctrlName,
            parent: null
        };
    }
    return false;
}
export const glbgetNodeTreeView = (node, controlsList, designControls) => {
    try {
        if (typeof designControls !== "object") {
            designControls = [];
        }
        let locontrolfilter = [], lsctrlname = "";
        locontrolfilter = controlsList.filter(x => x.ctrltype === node.getAttribute("ctrlcode"));
        if (locontrolfilter.length > 0) {
            lsctrlname = locontrolfilter[0].ctrlname;
        }
        let loparentlist = [{ id: 'H0', parent: null, content: lsctrlname, children: [] }];
        let lochildrenlist = [];
        for (let i = 0; i < node.children.length; i++) {
            let lolevel1 = node.children[i].querySelectorAll("[ctrlcode]");
            let locomponentlist = [];
            for (let j = 1; j < lolevel1.length; j++) {
                lsctrlname = "";
                locontrolfilter = designControls.filter(x => x.crntID === Number(lolevel1[j].getAttribute("id")));
                if (locontrolfilter.length > 0) {
                    lsctrlname = locontrolfilter[0].props.custom.caption;
                    locomponentlist.push({ id: Number(lolevel1[j].getAttribute("id")), props: locontrolfilter[0].props, parent: null, content: lsctrlname });
                }
            }
            lsctrlname = "";
            if (lolevel1.length > 0) {
                locontrolfilter = controlsList.filter(x => x.ctrltype === lolevel1[0].getAttribute("ctrlcode"));
                if (locontrolfilter.length > 0) {
                    lsctrlname = (i + 1) + "." + locontrolfilter[0].ctrlname;
                }
                lochildrenlist.push({ id: 'H' + (i + 1), parent: null, content: lsctrlname, children: locomponentlist });
            }
        }
        loparentlist[0].children = lochildrenlist;
        return loparentlist;
    }
    catch (err) {
        return [];
    }
}
function getChildNodes(node) {
    let children = [];
    for (let i = 0; i < node.children.length; i++) {
        let lolevel1 = node.children[i].querySelectorAll("[ctrlcode]");
        for (let j = 0; j < lolevel1.length; j++) {
        }
        children.push({ id: i + 1, parent: null, element: node.children[i] });
    }
    return children;
}
export const glbgetFileSize = (_size, _base64) => {
    if (_base64 !== undefined && _base64 !== '' && _base64 !== null) {
        let stringLength = _base64.length - 'data:image/png;base64,'.length;
        _size = 4 * Math.ceil((stringLength / 3)) * 0.5624896334383812;
    }
    var fSExt = new Array('Bytes', 'KB', 'MB', 'GB'),
        i = 0; while (_size > 900) { _size /= 1024; i++; }
    var exactSize = (Math.round(_size * 100) / 100) + ' ' + fSExt[i];
    return exactSize;
}
export const glbHTMLInjectionFound = (_psvalue) => {
    // let regex = /<(\/?\w+[^\n>]*\/?)>/ig;
    //let regex = /<*>/ig; Commend By ui455 for < or > Not Allowed For This Experssion
    let regex = /<(\"[^\"]*\"|'[^']*'|[^'\">])*>/; //Added By ui455
    if (regex.test(_psvalue)) {
        return true;
    }
    return false;
}

export const glbValidSpecialCharacters = (psvalue) => {
    // let regex = /^[a-zA-Z0-9]+$/;
    let regex = /^[a-zA-Z0-9.-\s]+$/;
    if (!regex.test(psvalue)) {
        return true;
    }
    return false;
}

export const glbEncryptData = (psdata, pstype) => {
    let loconfig = glbGetLocalStorage("config");
    let psencryptdata = '';
    if (pstype === undefined) {
        return psencryptdata = btoa(psdata);
    }
    else {
        psdata = btoa(psdata);
        if (loconfig !== undefined && loconfig !== null && loconfig.hasOwnProperty("edc")) {
            var iv = CryptoJS.enc.Hex.parse("101112131415161718191a1b1c1d1e1f");
            psencryptdata = CryptoJS.AES.encrypt(
                JSON.stringify(psdata),
                loconfig.edc,
                {
                    // mode: CryptoJS.mode.CBC,
                    padding: CryptoJS.pad.ZeroPadding,
                    iv: iv
                }
            ).toString();
        }
    }
    return psencryptdata;
}
export const glbDecryptData = (psdata) => {
    let loconfig = glbGetLocalStorage("config");
    let psdecryptdata = '';
    if (loconfig !== undefined && loconfig !== null && loconfig.hasOwnProperty("edc")) {
        const bytes = CryptoJS.AES.decrypt(psdata, loconfig.edc);
        psdecryptdata = JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
    }
    return psdecryptdata;
}
export const mobileCheck = function () {
    let check = false;
    (function (a) { if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0, 4))) check = true; })(navigator.userAgent || navigator.vendor || window.opera);
    return check;
};
export const mobileAndTabletCheck = function () {
    const ua = navigator.userAgent || navigator.vendor || window.opera;
    // iPadOS 13+ identifies as Mac, but has touch screen
    const isIpadOS = ua.includes('Macintosh') && 'ontouchend' in document;
    // Android tablet: has Android, but not Mobile
    const isAndroidTablet = /android/i.test(ua) && !/mobile/i.test(ua);
    // Android phone: has Android and Mobile
    const isAndroidPhone = /android.*mobile/i.test(ua);
    // iOS or generic tablet/phone/other
    const isIOSDevice = /iphone|ipod|ipad/i.test(ua);
    const isOtherMobile = /blackberry|iemobile|opera mini|mobile|tablet/i.test(ua);
    return (
        isIpadOS ||
        isAndroidTablet ||
        isAndroidPhone ||
        isIOSDevice ||
        isOtherMobile
    );
};
export const TabletCheck = function () {
    let check = false;
    (function (a) { if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino|android|ipad|playbook|silk/i.test(a) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0, 4))) check = true; })(navigator.userAgent || navigator.vendor || window.opera);
    return check;
};
export const glbScreenLoader = function (pbisloading, pstype) {
    let lsClassName = "";
    if (pstype !== undefined && pstype !== null && pstype !== "") {
        if (pstype === "dashboard" || pstype === 120 || pstype === "120") {
            lsClassName = 'dashboard'
        } else {
            lsClassName = "";
        }
    } else {
        lsClassName = "";
    }
    if (lsClassName === "" || lsClassName === null || lsClassName === undefined) {
        if (document.getElementById("ost-enable-loader") !== null && document.getElementById("ost-enable-loader") !== undefined) {
            if (pbisloading === true) {
                if (pstype === "eventloader") {
                    document.getElementById("ost-enable-loader").setAttribute('data-loaderfrom-event', 'true')
                }
                document.getElementById("ost-enable-loader").classList.add("ost-enable-loader");
            }
            else {
                if (pstype !== "eventloader") {
                    if (document.getElementById("ost-enable-loader").hasAttribute('data-loaderfrom-event')) {
                        if (document.getElementById("ost-enable-loader").getAttribute('data-loaderfrom-event') === "true") {
                            return
                        }
                    }
                }
                if (pstype === "eventloader" && document.getElementById("ost-enable-loader").hasAttribute('data-loaderfrom-event')) {
                    document.getElementById("ost-enable-loader").removeAttribute('data-loaderfrom-event')
                }
                document.getElementById("ost-enable-loader").classList.remove("ost-enable-loader")
            }
        }
    } else {
        if (document.getElementById("ost-enable-loader") !== null && document.getElementById("ost-enable-loader") !== undefined) {
            if (pbisloading === true) {

                document.getElementById("ost-enable-loader").classList.remove("ost-enable-loader1");
                document.getElementById("ost-enable-loader").classList.add("ost-enable-loader");
                document.getElementById("ost-enable-loader").classList.add("ost-enable-loader-" + lsClassName);
            }
            else {
                document.getElementById("ost-enable-loader").classList.add("ost-enable-loader1");
                document.getElementById("ost-enable-loader").classList.remove("ost-enable-loader");
                document.getElementById("ost-enable-loader").classList.remove("ost-enable-loader-" + lsClassName)
            }
        }
    }
};
export const glbScreenLoaderSpecificDIV = function (pbisloading, psdivid) {
    if (document.getElementById(psdivid) !== null && document.getElementById(psdivid) !== undefined) {
        if (pbisloading === true) {
            document.getElementById(psdivid).classList.add("ost-enable-loader");
            document.getElementById(psdivid).classList.remove("d-none");
        }
        else {
            document.getElementById(psdivid).classList.remove("ost-enable-loader")
            document.getElementById(psdivid).classList.add("d-none");
        }
    }
};
export const glbScreenLoaderPreview = function (pbisloading, psdivid, pstype, pbchange) {
    if (document.getElementById("ost-enable-loader") !== null && document.getElementById("ost-enable-loader") !== undefined) {
        if (document.getElementById("ost-enable-loader").classList.contains("ost-enable-loader")) {
            if (pbisloading === false) {
                glbScreenLoader(false);
            }
            else {
                return
            }
        }
    }
    if (document.getElementById("loadingprogress_" + psdivid) !== null && document.getElementById("loadingprogress_" + psdivid) !== undefined) {
        if (document.querySelector(".e-spinner-pane.e-spin-show") !== null && document.querySelector(".e-spinner-pane.e-spin-show") !== undefined) {
            //document.getElementById("loadingprogress_" + psdivid).classList.add("d-none");
            //Commended By Aravindhan.S 01/09/2025
            if (pbisloading === false) {
                document.getElementById("loadingprogress_" + psdivid).classList.add("d-none");
            }
            else {
                document.querySelector(".e-spinner-pane.e-spin-show").remove('show');
            }
        }
        else {
            if (pbisloading === true) {
                document.getElementById("loadingprogress_" + psdivid).classList.remove("d-none");
                if (pbchange !== undefined && pbchange !== null) {
                    if (pbchange) {
                        document.getElementById("loadingprogress_" + psdivid).classList.add("ost-pre-loader-nested-bg");
                    }
                }
            }
            else {
                document.getElementById("loadingprogress_" + psdivid).classList.add("d-none");
                if (pbchange !== undefined && pbchange !== null) {
                    if (!pbchange) {
                        document.getElementById("loadingprogress_" + psdivid).classList.remove("ost-pre-loader-nested-bg");
                    }
                }
            }
        }
    }
};
export const glbLoadFavourites = async (e) => {
    let loFavourites = [];
    let loResult = await CallApi({ method: "get", lookup: "dpcrud/rt", params: { id: 1476, ver: -1, alias: "BJwMlBgo9c", lparams: { "pnserialno": "" } }, toa: "u" });
    if (loResult.status === true) {
        loFavourites = loResult.data;
    }
    else {
        showAlert(loResult.errmsg, 'error');
    }
    glbSetLocalStorage("favourites", loFavourites);
}
export async function glbGetFavourites(pnsrcdoctyp, psnature, refAddRemoveFavourites) {
    if (pnsrcdoctyp > 0) {
        try {
            let loFavourites = glbGetLocalStorage("favourites");
            let lonaturefilter = [];
            if (psnature === "R" || psnature === "D" || psnature === "RP") {
                lonaturefilter = loFavourites.filter((e) => { return e.nature === psnature && e.refid === pnsrcdoctyp });
            }
            else {
                lonaturefilter = loFavourites.filter((e) => { return e.nature === psnature && e.refinfo !== "" && e.refinfo !== undefined && e.refinfo !== null && JSON.parse(e.refinfo).srcdoctyp === pnsrcdoctyp });
            }
            // console.log(lonaturefilter);
            if (refAddRemoveFavourites !== "" && refAddRemoveFavourites !== undefined && refAddRemoveFavourites !== null) {
                if (lonaturefilter.length > 0) {
                    refAddRemoveFavourites.current.classList.add("tc-text-brown");
                    refAddRemoveFavourites.current.title = "Remove from Favourites";
                }
                else {
                    refAddRemoveFavourites.current.classList.remove("tc-text-brown");
                    refAddRemoveFavourites.current.title = "Add To Favourites";
                }
            }
            return lonaturefilter;
        }
        catch (e) {
            return [];
        }
    } else {
        let loFavourites = [];
        let loResult = await CallApi({ method: "get", lookup: "dpcrud/rt", params: { id: 1476, ver: -1, alias: "BJwMlBgo9c", lparams: { "pnserialno": "" } }, toa: "u" });
        if (loResult.status === true) {
            loFavourites = loResult.data;
        }
        glbSetLocalStorage("favourites", loFavourites);
    }
    return;
    // for (let i = 0; i < lonaturefilter.length; i++) {
    //     let lorefinfo = JSON.parse(lonaturefilter[i].refinfo);
    //     if (lorefinfo.srcdoctyp === pnsrcdoctyp) {

    //     }
    //     lorefinfo.refid = lonaturefilter[i].refid;
    //     return lorefinfo;
    // }

}
export async function glbAddToFavourites(pojsonValue, refAddRemoveFavourites, psmode, pstype) {
    const tctappstore = glbGetLocalStorage("ssUserData");
    let url = "dpcrud";
    if (psmode == "edit") {
        url = "dpcrud/LogicalUpdate";
    }
    let lobody = {};
    lobody.id = 1476;
    lobody.alias = "vRu7mIZQcb";
    lobody.tcd = tctappstore.tcd;
    lobody.ver = -1;
    lobody.lparams = pojsonValue;
    // console.log(lobody);
    let loAPIResult = await CallApi({ method: "post", lookup: url, body: lobody, toa: "u", });
    if (loAPIResult.status === true) {
        if (refAddRemoveFavourites !== "" && refAddRemoveFavourites !== undefined && refAddRemoveFavourites !== null) {
            refAddRemoveFavourites.current.classList.add("tc-text-brown");
            refAddRemoveFavourites.current.title = "Remove from Favourites";
            showAlert('Added to your favourite list', 'success');
        }
        if (pstype === "setasdefault") {
            showAlert('Parameter has been set as default', 'success');
        }
        await glbGetFavourites();
    }
    else {
        if (refAddRemoveFavourites !== "" && refAddRemoveFavourites !== undefined && refAddRemoveFavourites !== null) {
            refAddRemoveFavourites.current.classList.remove("tc-text-brown");
        }
        CallConfirmDialog("warning", loAPIResult.errmsg);
        // setisLoading(false);
    }
    return loAPIResult;
}
export async function glbRemoveFromFavourites(pojsonValue, refAddRemoveFavourites, pstype) {
    let jsonValue = {
        serialno: pojsonValue.serialno,
        actstat: 0,
        trnusrid: pojsonValue.trnusrid
    };
    let url = "dpcrud/LogicalUpdate";
    let lobody = {};
    lobody.id = 1476;
    lobody.alias = "vRu7mIZQcb";
    // lobody.tcd = refScrLocalVariables.current.ScrlsDtSetTcd;
    lobody.ver = -1;
    lobody.lparams = jsonValue;
    // console.log(lobody);
    let loAPIResult = await CallApi({ method: "post", lookup: url, body: lobody, toa: "u", });
    if (loAPIResult.status === true) {
        if (refAddRemoveFavourites !== "") {
            if (refAddRemoveFavourites.current) {
                refAddRemoveFavourites.current.classList.remove("tc-text-brown");
                refAddRemoveFavourites.current.title = "Add To Favourites";
            }
        }
        if (refAddRemoveFavourites === "RP" && pstype === "setasdefault") {
            showAlert('Removed set as default', 'success');
        } else {
            showAlert('Removed from your favourite list', 'success');
        }
        glbGetFavourites();
    }
    else {
        CallConfirmDialog("warning", loAPIResult.errmsg);
        // setisLoading(false);
    }
    return loAPIResult;
}
export function dataURLtoFile(dataurl, filename) {
    var arr = dataurl.split(','),
        mime = arr[0].match(/:(.*?);/)[1],
        bstr = atob(arr[1]),
        n = bstr.length,
        u8arr = new Uint8Array(n);

    while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
    }
    return new File([u8arr], filename, { type: mime });
}
export function fnConvertImageDatatoUrl(imagedata) {
    var canvas = document.createElement('canvas');
    var ctx = canvas.getContext('2d');
    canvas.width = imagedata.width;
    canvas.height = imagedata.height;
    ctx.putImageData(imagedata, 0, 0);
    return canvas.toDataURL();
}
let ValidFileTypes = ['TXT', 'PDF', 'XLS', 'XLSX', 'DOC', 'DOCX', 'PNG', 'JPG', 'JPEG', 'SVG', 'JFIF', 'GIF', 'MP3', 'MP4', 'WMV', 'ZIP', 'PPT', 'PPTX', 'RAR', '7Z', 'CSV', 'IFC', 'JS', 'JSX', 'JSON', 'TS', 'TSX', 'RVT', 'STD', 'DWG', 'DXF', 'MCB', 'XER', 'ADS', 'ARB', 'XLSM', 'DB', 'ANL', 'APP', 'BMD', 'CFR', 'COD', 'CUT', 'DAY', 'DBS', 'DSP', 'EMF', 'EQL', 'NUM', 'REA', 'REI_SPRO_AUXILARY_DATA', 'SCN', 'SLG', 'METADATA', 'UID', 'THUMB', 'DPF', 'BAK', 'HEIC', 'HEVC']
export async function fnUploadFileToStorage(bodyFormData, abortsignal, fnUpdateProgressValue, fnUpdateUploadResponse, fnUpdateUploadError, fileid) {
    //To prevent upload of invalid file types
    if (bodyFormData !== undefined && bodyFormData !== null) {
        let uploadedFile = bodyFormData.get('File');
        if (uploadedFile !== undefined && uploadedFile !== null && uploadedFile.name !== undefined) {
            let fileExtension = uploadedFile.name.slice(uploadedFile.name.lastIndexOf('.') + 1, uploadedFile.name.length);
            //Handle file type and file size based on settings
            let isMaxFileSizeExceed = false;
            let fileSettings = glbGetAppSettings("as");
            if (fileSettings !== undefined && fileSettings !== null && fileSettings !== "") {
                if (fileSettings.aff !== undefined && fileSettings.aff !== null && fileSettings.aff !== "" && typeof fileSettings.aff !== 'boolean') {
                    if (fileSettings.aff.includes(',')) {
                        ValidFileTypes = fileSettings.aff.split(',');
                    } else {
                        ValidFileTypes = [fileSettings.aff];
                    }
                }
                if (fileSettings.mfs !== undefined && fileSettings.mfs !== null && fileSettings.mfs !== "" && typeof fileSettings.mfs !== 'boolean') {
                    var sizeInMB = (uploadedFile.size / (1024 * 1024)).toFixed(2);
                    if (parseInt(sizeInMB) > fileSettings.mfs) {
                        isMaxFileSizeExceed = true;
                    }
                }
            }
            let isValidFileIndex = ValidFileTypes.findIndex((type) => { return type.toUpperCase() == fileExtension.toUpperCase() });
            if (isValidFileIndex == -1) {
                fnUpdateUploadError(fileid, "File format not supported");
                let lresponseData = "";
                return lresponseData;
            }
            if (isMaxFileSizeExceed) {
                fnUpdateUploadError(fileid, "Maximum file size is " + fileSettings.mfs + "MB");
                let lresponseData = "";
                return lresponseData;
            }
        }
    }
    let lsGatewayURL = GatewayURL;
    let lsAttachURL = AttachURL;
    let loconfig = glbGetLocalStorage("config");
    if (loconfig !== undefined && loconfig !== null) {
        if (loconfig.hasOwnProperty("gatewayurl")) {
            lsGatewayURL = loconfig.gatewayurl;
        }
        if (loconfig.hasOwnProperty("attachurl")) {
            lsAttachURL = loconfig.attachurl;
        }
    }
    let lsAccessToken = glbGetLocalStorage("accesstoken");
    let loHeader;
    if (loconfig.hasOwnProperty("langpref") && loconfig["langpref"] === true) {
        loHeader = { "Content-Type": "multipart/form-data", "Authorization": "Bearer " + lsAccessToken, "toa": "d", "skpencypt": true };
    } else {
        loHeader = { "Content-Type": "multipart/form-data", "Authorization": "Bearer " + lsAccessToken, "toa": "d", "skpencypt": true, "skpdecypt": true };
    }
    var lresponseData = {};
    let signalValue;
    let value = undefined;
    if (abortsignal !== undefined && abortsignal !== null && abortsignal.length > 0) {
        signalValue = abortsignal.filter((value) => { return value[fileid] })[0];
        value = signalValue[fileid];
    }
    let UploadFile;
    if (bodyFormData.get("exceljson")) {
        UploadFile = "UploadExcel"
    } else {
        UploadFile = "UploadFile"
    }
    await axios({
        method: "post",
        url: lsGatewayURL + lsAttachURL + "attsvc/" + UploadFile,
        data: bodyFormData,
        headers: loHeader,
        signal: value != undefined ? value.signal : undefined,
        onUploadProgress: (p) => {
            let progressval = p.loaded / p.total;
            let percentage = parseInt(progressval * 100);
            if (typeof (fnUpdateProgressValue) !== 'undefined' && fnUpdateProgressValue !== "") {
                fnUpdateProgressValue(percentage, fileid);
            }
        }
    }).then(function (response) {
        let validated = true;
        if (response.data && response.data.status === false) {
            const errorMessage = response.data.error || "Upload failed";
            fnUpdateUploadError(fileid, errorMessage);
            lresponseData = null;
            return;
        }
        if (typeof (fnUpdateUploadResponse) !== 'undefined' && fnUpdateUploadResponse !== "") {
            validated = fnUpdateUploadResponse(fileid);
        }
        if (!validated) {
            lresponseData = null;
        } else {
            lresponseData = response;
        }
    }).catch(function (response) {
        if (typeof (fnUpdateUploadError) !== 'undefined' && fnUpdateUploadError !== "") {
            fnUpdateUploadError(fileid);
        }
        lresponseData = null;
    });

    if (loconfig !== undefined && loconfig !== null) {
        if (loconfig.hasOwnProperty("langpref") && loconfig["langpref"] === true) {
            if (lresponseData != null && lresponseData.data != null) {
                let decryptedData = glDecrypt(lresponseData.data);
                if (decryptedData !== undefined && decryptedData !== null && decryptedData !== "") {
                    lresponseData.data = JSON.parse(decryptedData);
                }
            }
        }
    }

    return lresponseData;
}
export async function fnRetrieveFileFromStorage(attkey, type) {
    let ipaddress = glbGetLocalStorage('ipaddress');
    let lsGatewayURL = GatewayURL;
    let lsAttachURL = AttachURL;
    let loconfig = glbGetLocalStorage("config");
    let doctype;
    if (loconfig !== undefined && loconfig !== null) {
        if (loconfig.hasOwnProperty("gatewayurl")) {
            lsGatewayURL = loconfig.gatewayurl;
        }
        if (loconfig.hasOwnProperty("attachurl")) {
            lsAttachURL = loconfig.attachurl;
        }
    }
    let lsAccessToken = glbGetLocalStorage("accesstoken");
    let loHeader = { "Authorization": "Bearer " + lsAccessToken, "toa": "d" };
    if (type === 'xlsx' || type === 'xls') {
        doctype = 'e'
    } else if (type === 'docx' || type === 'doc') {
        doctype = 'w'
    } else if (type === 'cdnImg') {
        doctype = 'di'
    } else {
        doctype = 'd'
    }
    let url = lsGatewayURL + lsAttachURL + "attsvc/RetriveFile?keyValue=" + attkey + "&sysip=" + ipaddress + "&connid=0&compressRequired=false&retriveType=" + doctype;
    if (lbneedUATLocal) {
        url = lsGatewayURL + lsAttachURL + "attsvc/RetriveFile?keyValue=" + attkey + "&connid=0&compressRequired=false&retriveType=" + doctype;
    }
    if (loconfig !== undefined && loconfig !== null) {
        if (loconfig.hasOwnProperty("langpref") && loconfig["langpref"] === true) {
            let baseurl = url.split('?')[0];
            let params = url.split('?')[1];
            let encryptedParams = glEncrypt(params).toString();
            url = baseurl + '?' + encryptedParams;
        } else {
            loHeader.skpencypt = true;
            loHeader.skpdecypt = true;
        }
    }

    var lresponseData = {};
    await axios({
        method: "get",
        url: url,
        headers: loHeader,
    }).then(function (response) {
        lresponseData = response;
    }).catch(function (response) {
        glbScreenLoader(false);
        if (window.location.pathname.includes("logout") === false) {
            CallConfirmDialog("warning", response);
        }
    });

    if (loconfig !== undefined && loconfig !== null) {
        if (loconfig.hasOwnProperty("langpref") && loconfig["langpref"] === true) {
            if (lresponseData != null && lresponseData.data != undefined && lresponseData.data != null) {
                let decryptedData = glDecrypt(lresponseData.data);
                lresponseData.data = JSON.parse(decryptedData);
            }
        }
    }

    if ((lresponseData !== undefined && lresponseData !== null && lresponseData.data !== undefined && lresponseData.data !== null) && ((lresponseData.data.status === false && (lresponseData.data.data === 2)) || (lresponseData.data.status === false && (lresponseData.data.data === 1)))) {
        CallConfirmDialog("info", "Session Expired!!! Redirecting to Login Page...");
        let currenthref = ReactSession.get("currenthref");
        window.open(currenthref, "_self");
    } else {
        return lresponseData;
    }
}
export async function fnRetrieveFileFromStorageResizeOption(attkey, resize, linkdata) {
    let lsGatewayURL = GatewayURL;
    let lsAttachURL = AttachURL;
    let lsresizeopt = "";
    if (resize !== undefined && resize !== null && resize !== "") {
        lsresizeopt = resize;
    }
    let lslinkdata = "";
    if (linkdata !== undefined && linkdata !== null && linkdata !== "") {
        lslinkdata = linkdata;
        if (typeof (linkdata) !== "string") {
            lslinkdata = JSON.stringify(linkdata);
        }
    }
    let loconfig = glbGetLocalStorage("config");
    if (loconfig !== undefined && loconfig !== null) {
        if (loconfig.hasOwnProperty("gatewayurl")) {
            lsGatewayURL = loconfig.gatewayurl;
        }
        if (loconfig.hasOwnProperty("attachurl")) {
            lsAttachURL = loconfig.attachurl;
        }
    }
    let lsAccessToken = glbGetLocalStorage("accesstoken");
    let loHeader = { "Authorization": "Bearer " + lsAccessToken, "toa": "d" };

    let url = lsGatewayURL + lsAttachURL + "attsvc/RetriveFile?keyValue=" + attkey + "&connid=0&compressRequired=false&retriveType=d&resize=" + lsresizeopt + "&linkdata=" + lslinkdata;
    if (loconfig !== undefined && loconfig !== null) {
        if (loconfig.hasOwnProperty("langpref") && loconfig["langpref"] === true) {
            let baseurl = url.split('?')[0];
            let params = url.split('?')[1];
            let encryptedParams = glEncrypt(params).toString();
            url = baseurl + '?' + encryptedParams;
        } else {
            loHeader.skpencypt = true;
            loHeader.skpdecypt = true;
        }
    }

    var lresponseData = {};
    await axios({
        method: "get",
        url: url,
        headers: loHeader,
    }).then(function (response) {
        lresponseData = response;
    }).catch(function (response) {
        glbScreenLoader(false);
        if (window.location.pathname.includes("logout") === false) {
            CallConfirmDialog("warning", response);
        }
    });

    if (loconfig !== undefined && loconfig !== null) {
        if (loconfig.hasOwnProperty("langpref") && loconfig["langpref"] === true) {
            if (lresponseData != null && lresponseData.data != undefined && lresponseData.data != null) {
                let decryptedData = glDecrypt(lresponseData.data);
                lresponseData.data = JSON.parse(decryptedData);
            }
        }
    }

    return lresponseData;
}
export async function fnDownloadAllFiles(attkeys, folderkeys) {
    let lsGatewayURL = GatewayURL;
    let lsAttachURL = AttachURL;
    let loconfig = glbGetLocalStorage("config");
    let doctype;
    if (loconfig !== undefined && loconfig !== null) {
        if (loconfig.hasOwnProperty("gatewayurl")) {
            lsGatewayURL = loconfig.gatewayurl;
        }
        if (loconfig.hasOwnProperty("attachurl")) {
            lsAttachURL = loconfig.attachurl;
        }
    }
    let lsAccessToken = glbGetLocalStorage("accesstoken");
    let loHeader = { "Authorization": "Bearer " + lsAccessToken, "toa": "d" };
    let url = lsGatewayURL + lsAttachURL + "attsvc/DownloadFiles?keyValue=" + attkeys + "&retriveType=d&folderKey=" + folderkeys;

    if (loconfig !== undefined && loconfig !== null) {
        if (loconfig.hasOwnProperty("langpref") && loconfig["langpref"] === true) {
            let baseurl = url.split('?')[0];
            let params = url.split('?')[1];
            let encryptedParams = glEncrypt(params).toString();
            url = baseurl + '?' + encryptedParams;
            loHeader.skpdecypt = true;
        } else {
            loHeader.skpencypt = true;
            loHeader.skpdecypt = true;
        }
    }

    var lresponseData = {};
    await axios({
        method: "get",
        url: url,
        headers: loHeader,
    }).then(function (response) {
        lresponseData = response;
    }).catch(function (response) {
        glbScreenLoader(false);
        if (window.location.pathname.includes("logout") === false) {
            CallConfirmDialog("warning", response);
        }
    });

    // if (loconfig !== undefined && loconfig !== null) {
    //     if (loconfig.hasOwnProperty("langpref") && loconfig["langpref"] === true) {
    //         if (lresponseData != null && lresponseData.data != undefined && lresponseData.data != null) {
    //             let decryptedData = glDecrypt(lresponseData.data);
    //             lresponseData.data = JSON.parse(decryptedData);
    //         }
    //     }
    // }

    if ((lresponseData !== undefined && lresponseData !== null && lresponseData.data !== undefined && lresponseData.data !== null) && ((lresponseData.data.status === false && (lresponseData.data.data === 2)) || (lresponseData.data.status === false && (lresponseData.data.data === 1)))) {
        CallConfirmDialog("info", "Session Expired!!! Redirecting to Login Page...");
        let currenthref = ReactSession.get("currenthref");
        window.open(currenthref, "_self");
    } else {
        return lresponseData;
    }
}
export async function glbTaskApprovalStatUpd(psSlno, pnUcode, pnAppStat) {
    let loFinalData = [];
    if (psSlno !== undefined && psSlno !== null && pnUcode !== undefined && pnUcode !== null && pnAppStat !== undefined && pnAppStat !== null) {
        let loResponse = await CallApi({ method: "get", lookup: "dpcrud/rt", params: { id: 1826, ver: -1, alias: "irFcktgJrn", lparams: { "psserialno": psSlno, "acsucd": pnUcode, "appstat": pnAppStat } }, toa: 'o' });
        if (loResponse.status === true) {
            loFinalData = loResponse.data
        }
        return await loFinalData;
    }
}

//convert file size bytes to MB/KB/..
export function fnConvertFileSizeBytes(bytes, decimalPoint) {
    if (bytes == 0) return '0 Bytes';
    var k = 1000,
        dm = decimalPoint || 2,
        sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'],
        i = Math.floor(Math.log(bytes) / Math.log(k));
    return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];
}
//Toolbar refreshment issue code -  Do not Remove
export const glbRefreshToolbar = (e, pselementidclass, pbneedtimeout) => {
    if (pbneedtimeout === undefined) {
        if (document.querySelector(pselementidclass) !== null && document.querySelector(pselementidclass) !== undefined) {
            let toolbarObj = document.querySelector(pselementidclass);

            if (toolbarObj !== undefined && toolbarObj !== null) {
                // toolbarObj.checkVisibility() === true
                if (toolbarObj.ej2_instances !== undefined && toolbarObj.ej2_instances !== null && toolbarObj.ej2_instances[0] !== undefined && toolbarObj.ej2_instances[0] !== null) {
                    let toolbarObj3 = toolbarObj.ej2_instances[0];
                    toolbarObj3.refreshOverflow();
                    // if (toolbarObj3.popObj !== undefined && toolbarObj3.popObj !== null) {
                    //     toolbarObj3.refreshOverflow();
                    // }
                }

            }

        }
    }
    else {
        setTimeout(() => {
            if (document.querySelector(pselementidclass) !== null) {
                let toolbarObj = document.querySelector(pselementidclass);
                if (toolbarObj !== undefined && toolbarObj !== null) {
                    if (toolbarObj.ej2_instances !== undefined && toolbarObj.ej2_instances !== null && toolbarObj.ej2_instances[0] !== undefined && toolbarObj.ej2_instances[0] !== null) {
                        let toolbarObj3 = toolbarObj.ej2_instances[0];
                        toolbarObj3.refreshOverflow();
                        // if (toolbarObj3.popObj !== undefined && toolbarObj3.popObj !== null) {
                        //     toolbarObj3.refreshOverflow();
                        // }
                    }

                }
            }
        }, 1200);
    }
    document.addEventListener('click', function (e) {
        var container = pselementidclass;
        if (!(e.target.closest(container) && e.target.closest(container) !== null && e.target.closest(container) !== undefined)) {


            let toolbarObj = document.querySelector(pselementidclass)
            if (toolbarObj !== undefined && toolbarObj !== null) {
                if (toolbarObj.ej2_instances !== undefined && toolbarObj.ej2_instances !== null && toolbarObj.ej2_instances[0] !== undefined && toolbarObj.ej2_instances[0] !== null) {
                    let toolbarObj2 = toolbarObj.ej2_instances[0];
                    if (toolbarObj2.popObj !== undefined && toolbarObj2.popObj !== null) {
                        toolbarObj2.popObj.hide()
                    }
                }

            }

        }
    });

}
//Sesstion Storage or Redux Storage
export const glbSetSessionStorage = async (pskey, pskeyval) => {
    if (pskey === "clearsession") {
        window.sessionStorage.clear();
    }
    else {
        window.sessionStorage.setItem(pskey, JSON.stringify(pskeyval));
    }
}
export const glbGetSessionStorage = async (pskey) => {
    try {
        let lovalue = window.sessionStorage.getItem(pskey);
        if (lovalue !== undefined && lovalue !== null && lovalue !== "") {
            return JSON.parse(lovalue);
        }
        else {
            return "";
        }
    }
    catch (err) {
        return "";
    }
}
export const glbGetStaticScreenList = (pstype) => {
    let loStaticScreen = {
        373: "LteEquipmentStatus",
        374: "LteEquipmenLog",
        516: "SterReport",
        519: "LteEquipmentProcess",
        523: "SterKnowledge",
        675: "CalibMovement",
        673: "CalibProcess",
        714: "HteProcess",
        802: "SterSOP",
        908: "DataSetCreation",
        1601: "PunchlistControl",
        2010: "OreRiskBPLog",
        1612: "PQIProcess",
        1622: "PQIProcess",
        2076: "OreRiskBPLog",
        2181: "SterKnowledge",
        3244: "AuditControl",
        2790597: "AuditControl",
        2790598: "AuditControl",
        4088: "SterBimControl"
    };
    if (pstype === "keyvalue") {
        return loStaticScreen;
    }
    else {
        let lokeys = Object.keys(loStaticScreen).map(function (str) {
            return parseInt(str);
        });
        return lokeys;
    }
}
export const glbUpdateCurrentScreenInfo = (poitem, pstype, psstartupref) => {
    if (poitem === "") {
        glbSetLocalStorage("ssCurrentScreenInfo", "");
        return;
    }
    let lorefinfo = {};
    if (!(poitem.startupref > 0)) {
        poitem.startupref = null;
    }
    lorefinfo.screentype = poitem.screentype;
    lorefinfo.typeid = poitem.typeid;
    lorefinfo.parentmenu = poitem.parentmenu;
    lorefinfo.startupref = poitem.startupref;
    if (poitem.appslno !== undefined) {
        lorefinfo.appslno = poitem.appslno;
    }
    glbSetLocalStorage("ssCurrentScreenInfo", lorefinfo);
}

export async function dpcrudTableCreate(psData) {
    try {
        let loResultData = [];
        if (Object.keys(psData).length > 0) {
            let loResponse = await CallApi({ method: "post", lookup: "DDL/CreateTable", body: psData, toa: "ds" });
            loResultData = loResponse;
        }
        return loResultData;
    }
    catch (e) {
        console.log(e)
        showAlert('Table Created - ' + e.message, 'error')
    }
}
export function glbAssignOtherDatasource(podataprops, psprops) {
    try {
        if (podataprops.length > 0) {
            let lsDataSource = psprops.datasource;
            let loDataSource = [];
            if (lsDataSource !== "" && lsDataSource !== undefined && lsDataSource !== null) {
                loDataSource = JSON.parse(lsDataSource);
                if (loDataSource.controlcode > 0) {
                    let lofiltercontrolprops = podataprops.filter(x => x.crntID === Number(loDataSource.controlcode));
                    if (lofiltercontrolprops.length > 0) {
                        lofiltercontrolprops = lofiltercontrolprops[0];
                        if (loDataSource.type === "TS" && lofiltercontrolprops.props.custom.datasource !== undefined && lofiltercontrolprops.props.custom.datasource !== null) {
                            psprops.datasource = lofiltercontrolprops.props.custom.datasource;
                            return psprops;
                        }
                    }
                }
            }
        }
    }
    catch (err) {
        console.log(err);
        return psprops
    }
    return psprops
}
export const glbScreenLoaderAttach = function (pbisloading, id) {
    if (document.getElementById("ost-enable-loader-attach" + id) !== null && document.getElementById("ost-enable-loader-attach" + id) !== undefined) {
        if (pbisloading === true) {
            document.getElementById("ost-enable-loader-attach" + id).classList.add("ost-enable-loader");
        }
        else {
            document.getElementById("ost-enable-loader-attach" + id).classList.remove("ost-enable-loader")
        }
    }
};
export const glbScreenLoaderDataTable = function (pbisloading, id, type) {
    if (type === "report") {
        if (document.getElementById("ost-enable-loader-report" + id) !== null && document.getElementById("ost-enable-loader-report" + id) !== undefined) {
            if (pbisloading === true) {
                document.getElementById("ost-enable-loader-report" + id).classList.remove("ost-enable-loader1")
                document.getElementById("ost-enable-loader-report" + id).classList.add("ost-enable-loader");
            }
            else {
                document.getElementById("ost-enable-loader-report" + id).classList.remove("ost-enable-loader")
                document.getElementById("ost-enable-loader-report" + id).classList.add("ost-enable-loader1");
            }
        }
    } else {
        if (document.getElementById("ost-enable-loader-datatable" + id) !== null && document.getElementById("ost-enable-loader-datatable" + id) !== undefined) {
            if (pbisloading === true) {
                document.getElementById("ost-enable-loader-datatable" + id).classList.remove("ost-loading-disable")
                document.getElementById("ost-enable-loader-datatable" + id).classList.add("ost-loading-enable");
            }
            else {
                document.getElementById("ost-enable-loader-datatable" + id).classList.remove("ost-loading-enable")
                document.getElementById("ost-enable-loader-datatable" + id).classList.add("ost-loading-disable");
            }
        }
    }
};
export const glbScreenLoaderChart = function (pbisloading, id) {
    if (document.getElementById("ost-enable-loader-datatable" + id) !== null && document.getElementById("ost-enable-loader-datatable" + id) !== undefined) {
        if (pbisloading === true) {
            document.getElementById("ost-enable-loader-datatable" + id).classList.remove("ost-loading-disable")
            document.getElementById("ost-enable-loader-datatable" + id).classList.add("ost-loading-enable");
        }
        else {
            document.getElementById("ost-enable-loader-datatable" + id).classList.remove("ost-loading-enable")
            document.getElementById("ost-enable-loader-datatable" + id).classList.add("ost-loading-disable");
        }
    }
}
export const glbScreenLoaderFileUpload = function (pbisloading, id) {
    if (document.getElementById("ost-enable-loader-fileupload" + id) !== null && document.getElementById("ost-enable-loader-fileupload" + id) !== undefined) {
        if (pbisloading === true) {
            document.getElementById("ost-enable-loader-fileupload" + id).classList.add("ost-enable-loader");
        }
        else {
            document.getElementById("ost-enable-loader-fileupload" + id).classList.remove("ost-enable-loader")
        }
    }
};
export const GlbGlobalThemeLoading = function () {
    return (
        <>
            {/* <div className='ost-lazy-loading-codesplitting'> */}
            {/* <div className="ost-lazy-dots"></div> */}
            {/* <div className="ost-pre-loader-container ost-enable-loader" tabIndex="-1" >
                <div className="ost-pre-loader">
                    <div className="ost-pre-loader__bar"></div>
                    <div className="ost-pre-loader__bar"></div>
                    <div className="ost-pre-loader__bar"></div>
                    <div className="ost-pre-loader__bar"></div>
                    <div className="ost-pre-loader__bar"></div>
                    <div className="ost-pre-loader__ball"></div>
                </div>

            </div> */}
            {/* </div> */}
        </>
    )
};
export function glbChangeDisplayDateFormat(pddate, pstype, psformat) {
    let lddate = "";
    try {
        if (pddate !== undefined && pddate !== null && pddate !== "") {
            lddate = pddate;
            if (typeof psformat === "string" && psformat !== "") {
                try {
                    let lsvalue = lddate;
                    let lsformat = psformat;
                    let lssymbol = lsformat.includes("-") ? "-" : "/";
                    let lstimeSymbol = ":";

                    let lsformatsplit = psformat.split(/[\s:/\-]+/);
                    let lsdate = new Date(lsvalue);
                    let lsformateddate = "";

                    for (let i = 0; i < lsformatsplit.length; i++) {
                        let lssplitedpart = "";

                        if (lsformatsplit[i] === "dd") {
                            lssplitedpart = String(lsdate.getDate()).padStart(2, '0');
                        } else if (lsformatsplit[i] === "MM") {
                            lssplitedpart = String(lsdate.getMonth() + 1).padStart(2, '0');
                        } else if (lsformatsplit[i] === "yyyy") {
                            lssplitedpart = lsdate.getFullYear();
                        } else if (lsformatsplit[i] === "yy") {
                            lssplitedpart = String(lsdate.getFullYear() % 100).padStart(2, '0');
                        } else if (lsformatsplit[i] === "MMM") {
                            lssplitedpart = lsdate.toLocaleString('default', { month: 'short' }).toUpperCase();
                        }
                        else if (pstype === "datetime") {
                            if (lsformatsplit[i] === "HH") {
                                lssplitedpart = String(lsdate.getHours()).padStart(2, '0');
                            } else if (lsformatsplit[i] === "hh") {
                                let hour = lsdate.getHours() % 12 || 12;
                                lssplitedpart = String(hour).padStart(2, '0');
                            } else if (lsformatsplit[i] === "mm") {
                                lssplitedpart = String(lsdate.getMinutes()).padStart(2, '0');
                            } else if (lsformatsplit[i] === "ss") {
                                lssplitedpart = String(lsdate.getSeconds()).padStart(2, '0');
                            } else if (lsformatsplit[i] === "a") {
                                lssplitedpart = (i > 0 ? " " : "") + (lsdate.getHours() >= 12 ? "PM" : "AM");
                            }
                        }

                        lsformateddate += lssplitedpart;

                        if (i < lsformatsplit.length - 1) {
                            const lscurrentsplitedpart = lsformatsplit[i];
                            const lsnextsplitedpart = lsformatsplit[i + 1];
                            const lsiscurrentdatepart = ["dd", "MM", "yyyy", "yy", "MMM"].includes(lscurrentsplitedpart);
                            const lsisnextdatepart = ["dd", "MM", "yyyy", "yy", "MMM"].includes(lsnextsplitedpart);
                            const lsisnexttimepart = ["HH", "hh", "mm", "ss", "a"].includes(lsnextsplitedpart);
                            if (lsiscurrentdatepart && lsisnextdatepart) {
                                lsformateddate += lssymbol;
                            } else if (lsiscurrentdatepart && lsisnexttimepart) {
                                lsformateddate += " ";
                            } else if (lsisnexttimepart && lsnextsplitedpart !== "a") {
                                lsformateddate += lstimeSymbol;
                            }
                        }
                    }

                    return lsformateddate;
                } catch (error) {

                }
            }
            else if (pstype === "datetime") {
                lddate = lddate.getDate() + "-" + parseInt(lddate.getMonth() + 1) + "-" + lddate.getFullYear() + " " + lddate.toLocaleTimeString();
            }
            else {
                lddate = lddate.getDate() + "-" + parseInt(lddate.getMonth() + 1) + "-" + lddate.getFullYear();
            }
        }
        return lddate;
    }
    catch (err) {
        return lddate;
    }
}
export function glbGetLanguageJSON(psapplang) {
    let lolang = [{ "code": "en", "shrtname": "English", "name": "English", "rtl": false }, { "code": "ta", "shrtname": "தமிழ்", "name": "Tamil", "rtl": false }, { "code": "ja", "shrtname": "日本語", "name": "Japanese", "rtl": false }, { "code": "ar", "shrtname": "عربي", "name": "Arabic", "rtl": true }, { "code": "hi", "name": "Hindi", "shrtname": "हिंदी", "rtl": false }, { "code": "te", "name": "Telugu", "shrtname": "తెలుగు", "rtl": false }, { "code": "ml", "name": "Malayalam", "shrtname": "മലയാളം", "rtl": false }];
    if (psapplang === "") {
        lolang = [{ "code": "en", "shrtname": "English", "name": "English", "rtl": false }];
        glbSetLocalStorage("deflang", "en");
    }
    else {
        if (typeof psapplang === "string" && psapplang !== "" && psapplang.split(",").length > 0) {
            lolang = lolang.filter(x => psapplang.split(",").indexOf(x.code) !== -1);
            if (lolang.length === 1) {
                glbSetLocalStorage("deflang", lolang[0].code);
            }
        }
    }
    return lolang;
}

export async function glbAssignLanguageProperty(podata) {
    try {
        let loUserconfig = glbGetLocalStorage('ssUserConfig');
        if (loUserconfig !== undefined && loUserconfig !== null && loUserconfig !== "") {
            if (loUserconfig.defvalues.language === null) {
                loUserconfig.defvalues.language = "en";
            }
            let lstext = [];
            if (podata.length > 0) {
                lstext = Object.keys(podata[0]).filter(e => {
                    let str = e.toLowerCase()
                    if (str.match(loUserconfig.defvalues.language.toLowerCase() + "_")) {
                        return e
                    }
                })
            }
            if (podata.length > 0) {
                if (lstext.length > 0) {
                    podata.map(function (r) {
                        r["en_" + lstext[0].split(loUserconfig.defvalues.language + "_")[1]] = r[lstext[0].split(loUserconfig.defvalues.language + "_")[1]];
                        r[lstext[0].split(loUserconfig.defvalues.language + "_")[1]] = r[lstext[0]];
                        r["labelfld"] = lstext[0].split(loUserconfig.defvalues.language + "_")[1];
                        return r;
                    });
                }
                else {
                    if (loUserconfig.defvalues.language === "en") {
                        let lsssUserData = glbGetLocalStorage("ssUserData");
                        let loaddinfo = JSON.parse(lsssUserData.addinfo);
                        if (typeof loaddinfo.applang === "string" && loaddinfo.applang !== "") {
                            let lssplitapplang = loaddinfo.applang.split(",");
                            for (let i = 0; i < lssplitapplang.length; i++) {
                                lstext = Object.keys(podata[0]).filter(e => {
                                    let str = e.toLowerCase()
                                    if (str.match(lssplitapplang[i].toLowerCase() + "_")) {
                                        return e
                                    }
                                })
                                if (lstext.length > 0) {
                                    if (podata[0].hasOwnProperty("en_" + lstext[0].split(lssplitapplang[i].toLowerCase())) === false) {
                                        podata.map(function (r) {
                                            r["en_" + lstext[0].split(lssplitapplang[i].toLowerCase() + "_")[1]] = r[lstext[0].split(lssplitapplang[i].toLowerCase() + "_")[1]];
                                            r["labelfld"] = lstext[0].split(lssplitapplang[i].toLowerCase() + "_")[1];
                                            return r;
                                        });
                                        break;
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
        return podata;
    }
    catch (err) {
        return podata;
    }
}
export function glbRandomData(looptstr) {
    let returndata = [];
    let characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz';
    //JS All DataType's  String , Number , BigInt , Boolean , Array, Object ,Date, Datetime, 
    const generateString = (len) => {
        let lsreturns = ''
        len = len === undefined || len === null || len === '' ? 5 : len
        for (let i = 0; i < len; i++) {
            let lnstring = Math.floor(Math.random() * characters.length);
            lsreturns += characters.substring(lnstring, lnstring + 1);
        }
        return lsreturns;

    }
    const generateNumber = (min, max) => {
        min = min !== undefined && min !== '' && min !== null ? min : 1;
        max = max !== undefined && max !== '' && max !== null ? max : 100;
        let lnreturns = Math.floor(Math.random() * (max - min) + min);
        return lnreturns
    }
    const generateBoolean = () => {
        return Math.random() >= 0.5
    }
    const generateDate = (startdate, enddate) => {
        let lsreturns = '';

        if (enddate === undefined || enddate === null || enddate === '') {
            enddate = new Date()
            startdate = new Date()
            let day = enddate.getDate() - 12
            startdate.setDate(day)
        }
        let minValue = startdate.getTime();
        let maxValue = enddate.getTime();
        lsreturns = Math.floor(Math.random() * (maxValue - minValue + 1) + minValue);
        lsreturns = new Date(lsreturns)
        lsreturns = lsreturns.getFullYear() + '/' + lsreturns.getMonth() + '/' + lsreturns.getDate()
        return lsreturns
    }
    const generateArray = () => {
        let lareturn = new Array(10);
        lareturn = lareturn.fill(0).map(() => Math.floor(Math.random() * 100))
        return lareturn
    }

    let loinsideobject = {};
    let lnlength = 5;
    for (let i = 0; i < lnlength; i++) {
        loinsideobject = {}
        for (let j = 0; looptstr.length > j; j++) {
            switch (looptstr[j].datatype) {
                case "String":
                    loinsideobject[looptstr[j]['fieldname']] = generateString(looptstr[j]['max']);
                    break
                case "Number":
                    loinsideobject[looptstr[j]['fieldname']] = generateNumber(looptstr[j]['min'], looptstr[j]['max']);
                    break
                case "Boolean":
                    loinsideobject[looptstr[j]['fieldname']] = generateBoolean();
                    break
                case "Date":
                    loinsideobject[looptstr[j]['fieldname']] = generateDate(new Date(looptstr[j]['startdate']), looptstr[j]['enddate'] === '' || looptstr[j]['enddate'] === undefined || looptstr[j]['enddate'] === null ? looptstr[j]['enddate'] : new Date(looptstr[j]['enddate']));
                    break
                case "Array":
                    loinsideobject[looptstr[j]['fieldname']] = generateArray()
                    break


            }
        }
        returndata.push(loinsideobject);
    }
    return returndata


}
export default function glbAddminutes(date, minutes) {
    let lsterundata = ''
    if ((date === undefined || date === '' || date === null) || (minutes === undefined || minutes === '' || minutes === null)) {
        date = new Date();
        lsterundata = date;
    }
    else {
        lsterundata = date.setMinutes(date.getMinutes() + minutes);
    }
    return lsterundata
}
export function glbCheckValidData(psvalue) {
    if (psvalue === undefined || psvalue === null || psvalue === "" || (typeof psvalue === "object" && psvalue !== null && psvalue.length === 0)) {
        return false;
    }
    else {
        return true;
    }
}

export function glbGetAppSettings(pskey) {
    let loappsett = glbGetLocalStorage("appsett");
    if (loappsett !== "" && loappsett !== undefined && loappsett !== null && loappsett.length > 0) {
        if (loappsett[0].hasOwnProperty(pskey)) {
            return loappsett[0][pskey];
        }
    }
    return "";
}
export async function glbEvaluateTaskCondition(pscondition, potaskinfo, poscreeninfo) {
    try {
        let lnvalue = glbGetLocalStorage("orgid");
        let lolocalvar = { dsocd: lnvalue };
        let lsprcond = pscondition.prcond;
        if (lsprcond !== undefined && lsprcond !== "" && lsprcond !== null) {
            pscondition.disptype = "O";
            lsprcond = lsprcond.replaceAll("=", "==");
            lsprcond = lsprcond.replaceAll(">==", ">=");
            lsprcond = lsprcond.replaceAll("<==", "<=");
            lsprcond = lsprcond.replaceAll("ts.tskst", "ts.tostat");
            // console.log(lsprcond);
            // console.log(potaskinfo, poscreeninfo);
            let lssplitstring = lsprcond.split("ts.");
            for (let i = 1; i < lssplitstring.length; i++) {
                var match = /[!=><&&|() ]/.exec(lssplitstring[i]);
                if (match) {
                    let lnposition = match.index;
                    let lsvariable = lssplitstring[i].substring(0, lnposition);
                    if (typeof potaskinfo === "object" && potaskinfo !== null && potaskinfo !== undefined && potaskinfo.hasOwnProperty(lsvariable)) {
                        lolocalvar["ts" + lsvariable] = potaskinfo[lsvariable];
                    }
                    else {
                        lolocalvar["ts" + lsvariable] = "";
                    }
                    let lssplitnotin = lssplitstring[i].split("not in");
                    for (let i = 1; i < lssplitnotin.length; i++) {
                        let lstemp = lssplitstring[i];
                        lssplitstring[i] = lssplitnotin[i].replaceAll("(", "[").replaceAll(")", "].indexOf(ts." + lsvariable + ")==-1");
                        lsprcond = lsprcond.replaceAll("ts." + lstemp, lssplitstring[i]);
                    }
                    // let lssplitin = lssplitstring[i].split("in");
                    let lssplitin = lssplitstring[i].split(/\bin\b/);
                    for (let i = 1; i < lssplitin.length; i++) {
                        let lstemp = lssplitstring[i];
                        lssplitstring[i] = lssplitin[i].replaceAll("(", "[").replaceAll(")", "].indexOf(ts." + lsvariable + ")!==-1");
                        lsprcond = lsprcond.replaceAll("ts." + lstemp, lssplitstring[i]);
                    }
                    lsprcond = lsprcond.replaceAll("ts." + lsvariable, "lolocalvar['ts" + lsvariable + "']");
                    // console.log(lsvariable);
                }
            }
            lssplitstring = lsprcond.split("ds.");
            for (let i = 1; i < lssplitstring.length; i++) {
                var match = /[!=><&&|() ]/.exec(lssplitstring[i]);
                if (match) {
                    let lnposition = match.index;
                    let lsvariable = lssplitstring[i].substring(0, lnposition);
                    if (lsvariable !== "ocd") {
                        if (typeof poscreeninfo === "object" && poscreeninfo !== null && poscreeninfo !== undefined && poscreeninfo.hasOwnProperty(lsvariable)) {
                            lolocalvar["ds" + lsvariable] = poscreeninfo[lsvariable];
                        }
                        else {
                            lolocalvar["ds" + lsvariable] = "";
                        }
                    }
                    let lssplitnotin = lssplitstring[i].split("not in");
                    for (let i1 = 1; i1 < lssplitnotin.length; i1++) {
                        let lstemp = lssplitstring[i];
                        lssplitstring[i] = lssplitnotin[i1].replaceAll("(", "[").replaceAll(")", "].indexOf(ds." + lsvariable + ")==-1");
                        lsprcond = lsprcond.replaceAll("ds." + lstemp, lssplitstring[i]);
                    }
                    // let lssplitin = lssplitstring[i].split("in");
                    let lssplitin = lssplitstring[i].split(/\bin\b/);
                    for (let i2 = 1; i2 < lssplitin.length; i2++) {
                        let lstemp = lssplitstring[i];
                        lssplitstring[i] = lssplitin[i2].replaceAll("(", "[").replaceAll(")", "].indexOf(ds." + lsvariable + ")!==-1");
                        lsprcond = lsprcond.replaceAll("ds." + lstemp, lssplitstring[i]);
                    }
                    lsprcond = lsprcond.replaceAll("ds." + lsvariable, "lolocalvar['ds" + lsvariable + "']");
                }
            }
            pscondition.evalprcond = lsprcond;
            pscondition.evalvalue = eval(lsprcond);
            console.log(pscondition.tuuid, pscondition.tsktitl, pscondition.evalvalue, lolocalvar);
        }
    }
    catch (err) {
        console.log(err);
    }
    return pscondition;
}
export const fnGetDirectBulkData = async (pdataref) => {
    let loresponse = await CallApi({ method: "get", lookup: "dpcrud/gd", params: { id: "4112", alias: -1, ver: -1, keyval: pdataref }, toa: "d" });
    if (loresponse.status) {
        let directdata = loresponse['data']['tphstockdata'].objdata !== undefined && loresponse['data']['tphstockdata'].objdata !== null ? JSON.parse(loresponse['data']['tphstockdata'].objdata) : '';
        return directdata
    }
    return []
}
export async function glbValidIPAddress(psipaddress) {
    let loHeader = {
        "Access-Control-Allow-Origin": "*",
        "Access-Control-Allow-Methods": "GET",
        "Access-Control-Allow-Headers": "Origin, Content-Type, X-Auth-Token",
    };
    axios.get(psipaddress, { headers: loHeader }).then((response) => {
        console.log(response);
    }).catch((error) => {
        console.log("Error: " + error.message);
    })
}

export const glEncrypt = (plain) => {
    if (plain !== undefined && plain !== null) {

        let aeskey = process.env.REACT_APP_TONY;
        let aesiv = process.env.REACT_APP_SPMAN;

        if (aeskey != null && aesiv != null) {
            var key = CryptoJS.enc.Base64.parse(aeskey);
            var iv = CryptoJS.enc.Base64.parse(aesiv);
            let data;
            if (plain.toString().trim().startsWith('[') || plain.toString().trim().startsWith('{')) {
                data = JSON.stringify(plain);
            } else {
                data = plain;
            }
            return CryptoJS.AES.encrypt(data, key, {
                iv: iv
            });
        }
    }

    return "";
}

export const glDecrypt = (cipher) => {
    if (cipher !== undefined && cipher !== null) {

        let aeskey = process.env.REACT_APP_TONY;
        let aesiv = process.env.REACT_APP_SPMAN;

        if (aeskey != null && aesiv != null) {
            var key = CryptoJS.enc.Base64.parse(aeskey);
            var iv = CryptoJS.enc.Base64.parse(aesiv);
            return CryptoJS.AES.decrypt(cipher, key, { iv: iv }).toString(CryptoJS.enc.Utf8);
        }
    }

    return "";
}
export const glbAllowTimeSheeetOnly = (pbvalue) => {
    try {
        let lshomepagemodel = glbGetLocalStorage("homepagemodel");
        if (lshomepagemodel === "m2") {
            if (pbvalue === true) {
                if (document.querySelector("#divorecontrolhome") !== null) {
                    document.querySelector("#divorecontrolhome").classList.add("ost-timesheet-pe-none");
                }
                document.querySelector("#tb_newhomemodel").closest(".e-toolbar-item").classList.add("ost-timesheet-pe-none");
                //added for model2 icons hidden
                if (document.querySelector(".ost-sidebar-listitemsview-container") !== null) {
                    document.querySelector(".ost-sidebar-listitemsview-container").classList.add("ost-timesheet-pe-none");
                }
                if (document.querySelector("#tb_settings")) {
                    document.querySelector("#tb_settings").closest(".e-toolbar-item").classList.add("ost-timesheet-pe-none");
                }
                if (document.querySelector("#tb_workboard")) {
                    document.querySelector("#tb_workboard").closest(".e-toolbar-item").classList.add("ost-timesheet-pe-none");
                }
                if (document.querySelector("#tb_documents")) {
                    document.querySelector("#tb_documents").closest(".e-toolbar-item").classList.add("ost-timesheet-pe-none");
                }
                if (document.querySelector("#tb_messages")) {
                    document.querySelector("#tb_messages").closest(".e-toolbar-item").classList.add("ost-timesheet-pe-none");
                }
            }
            else {
                if (document.querySelector("#divorecontrolhome") !== null) {
                    document.querySelector("#divorecontrolhome").classList.remove("ost-timesheet-pe-none");
                }
                document.querySelector("#tb_newhomemodel").closest(".e-toolbar-item").classList.remove("ost-timesheet-pe-none");
                //added for model2 icons hidden
                if (document.querySelector(".ost-sidebar-listitemsview-container") !== null) {
                    document.querySelector(".ost-sidebar-listitemsview-container").classList.remove("ost-timesheet-pe-none");
                }
                if (document.querySelector("#tb_settings")) {
                    document.querySelector("#tb_settings").closest(".e-toolbar-item").classList.remove("ost-timesheet-pe-none");
                }
                if (document.querySelector("#tb_workboard")) {
                    document.querySelector("#tb_workboard").closest(".e-toolbar-item").classList.remove("ost-timesheet-pe-none");
                }
                if (document.querySelector("#tb_documents")) {
                    document.querySelector("#tb_documents").closest(".e-toolbar-item").classList.remove("ost-timesheet-pe-none");
                }
                if (document.querySelector("#tb_messages")) {
                    document.querySelector("#tb_messages").closest(".e-toolbar-item").classList.remove("ost-timesheet-pe-none");
                }
            }
        }
        else {
            if (pbvalue === true) {
                if (document.querySelector(".ost-sidebar-listitemsview-container") !== null) {
                    document.querySelector(".ost-sidebar-listitemsview-container").classList.add("ost-timesheet-pe-none");
                }
                if (document.querySelector(".ost-layout-sub-header") !== null) {
                    document.querySelector(".ost-layout-sub-header").classList.add("ost-timesheet-pe-none");
                }
                if (document.querySelector("#divhomepagepart") !== null) {
                    document.querySelector("#divhomepagepart").classList.add("ost-timesheet-pe-none");
                }
                if (document.querySelector("#divtapfav") !== null) {
                    document.querySelector("#divtapfav").classList.add("ost-timesheet-pe-none");
                }
            }
            else {
                if (document.querySelector(".ost-sidebar-listitemsview-container") !== null) {
                    document.querySelector(".ost-sidebar-listitemsview-container").classList.remove("ost-timesheet-pe-none");
                }
                if (document.querySelector(".ost-layout-sub-header") !== null) {
                    document.querySelector(".ost-layout-sub-header").classList.remove("ost-timesheet-pe-none");
                }
                if (document.querySelector("#divhomepagepart") !== null) {
                    document.querySelector("#divhomepagepart").classList.remove("ost-timesheet-pe-none");
                }
                if (document.querySelector("#divtapfav") !== null) {
                    document.querySelector("#divtapfav").classList.remove("ost-timesheet-pe-none");
                }
            }
        }
    }
    catch (err) {
        console.log(err);
    }
}
export function glbIsJson(str) {
    try {
        JSON.parse(str);
    } catch (e) {
        return false;
    }
    return true;
}
export function glbRecordLogWithTime(pstype) {
    let lddate = new Date();
    console.log(pstype, lddate.getHours() + ":" + lddate.getMinutes() + ":" + lddate.getSeconds() + ":" + lddate.getMilliseconds() + "");
}
export function TempLazyLoading(props) {
    return (
        <div className={`ost-form-control-loading ${props.custom.isinitdata === false ? "" : "d-none"} `}>
            <div className="spinner-border spinner-border-sm text-secondary" role="status">
                <span className="visually-hidden">Loading...</span>
            </div>
        </div>
    )
}
export function fnlChangeApplicationLanguage(pslang, psprevlang) {
    if (loLanguage.length > 0 && loLanguage[0].hasOwnProperty("ln" + pslang) === false) {
        // glbScreenLoader(false);
        return;
    }
    // glbScreenLoader(true);
    setTimeout(() => {
        var html = document.querySelector('html');
        var walker = document.createTreeWalker(html, NodeFilter.SHOW_TEXT);
        const bootstrapCSS = document.getElementById('css-bootstrap-bootstrap');
        const bootstrapRTLCSS = document.getElementById('css-bootstrap-bootstrap-rtl');

        var node;

        if (pslang === "ar") {
            // Enable RTL
            html.setAttribute("dir", "rtl");
            bootstrapRTLCSS.disabled = false;
            bootstrapCSS.disabled = true;
        }
        else {
            html.removeAttribute("dir");
            bootstrapRTLCSS.disabled = true;
            bootstrapCSS.disabled = false;
        }

        if (pslang === undefined) {
            pslang = document.getElementsByTagName("html")[0].getAttribute("lang");
        }
        if (psprevlang === undefined) {
            psprevlang = glbGetLocalStorage("deflang");
            glbSetLocalStorage("prevlang", psprevlang);
        }
        else if (psprevlang !== "") {
            psprevlang = glbGetLocalStorage("prevlang");
        }
        if (psprevlang === "") {
            psprevlang = "en";
            glbSetLocalStorage("prevlang", psprevlang);
        }
        glbSetLocalStorage("deflang", pslang);
        document.getElementsByTagName("html")[0].setAttribute("lang", pslang);
        while (node = walker.nextNode()) {
            if (typeof node.nodeValue === "string" && node.nodeValue.trim() !== "") {
                let lofilter = loLanguage.filter(x => x["ln" + psprevlang] == node.nodeValue);
                if (lofilter.length > 0 && lofilter[0]["ln" + pslang] !== undefined) {
                    node.nodeValue = node.nodeValue.replace(lofilter[0]["ln" + psprevlang], lofilter[0]["ln" + pslang]);
                }
            }
        }
        // glbScreenLoader(false);
    }, 1000); // Corrected: 1000 milliseconds delay
}
export async function glbUpdateTaskStatus(pntskslno, pntskst) {
    try {
        return await CallApi({ method: "get", lookup: "dpcrud/rt", params: { id: 23, ver: -1, alias: "D009", lparams: { "pntskslno": pntskslno, "pntskst": pntskst } }, toa: "d" });
    }
    catch (err) {
        return { status: false, errmsg: err };
    }
}
export async function glbUpdateDeleteTask(psrecaltsk, pnupdtsk, pntskst) {
    try {
        return await CallApi({ method: "get", lookup: "dpcrud/rt", params: { id: 9552, ver: -1, alias: -1, lparams: { "psrecaltsk": psrecaltsk, "pnupdtsk": pnupdtsk, "pntskst": pntskst } }, toa: "o" });
    }
    catch (err) {
        return { status: false, errmsg: err };
    }
}
export async function fnGetFileFromStorage(pnvalue) {
    let loFinalData = "";
    let loparams = { "attinfo": pnvalue }
    let loResponse = await CallApi({ method: "get", lookup: "attsvc/AttachCopy", params: loparams, toa: 'a' });
    if (loResponse.status === true) {
        if (Array.isArray(loResponse.data)) {
            loResponse.data.forEach(item => {
                if (item.addinfo === "") {
                    item.addinfo = null;
                }
            });
        }
        loFinalData = {
            "attachdet": loResponse.data,
            "befaftkeys": []
        };
    }
    return loFinalData;
}

export function glbGetFolderFromStorage(folderString, foldertyp = "Folder") {
    try {
        let lsUserData = glbGetLocalStorage("ssUserData");
        let creteby = lsUserData?.username || "";

        const lnshortuid = new ShortUniqueId({ length: 10 });

        const folderNames = folderString
            .split("#")
            .filter(name => name.trim() !== "");

        const attachdet = folderNames.map(name => ({
            id: lnshortuid(),
            prntslno: null,
            name: name.trim(),
            type: foldertyp,
            filesize: "",
            modified: new Date().toDateString(),
            createdby: creteby,
            addinfo: {},
            srcref: "",
            wfid: "",
            prname: "",
            attflnm: "",
            revision: 0,
            verId: lnshortuid()
        }));

        const jsonData = {
            attachdet: attachdet,
            befaftkeys: []
        };

        return JSON.stringify(jsonData);

    } catch (error) {
        console.error("Error creating folder JSON:", error);
        return null;
    }
}

export const glbHasApplicableRoles = function (psappslno, psrole) { //added for return value if app and role exits
    let lsreturns = false;
    let lsUserData = glbGetLocalStorage("ssUserData");
    let lsroles = psrole.toString().split(",")
    let lsapps = lsUserData.apprights.filter(x => x.appslno == psappslno)
    lsapps.forEach(app => {
        if (lsroles.includes(app.roles.toString())) {
            lsreturns = true;
        }
    });
    return lsreturns;
}

export const glbGetScheduleRecurrence = async function (lspattern, ldfromdate, ldtodate, lnoccurance) {
    try {
        if (lspattern === undefined || lspattern === null || lspattern.trim() === "") {
            showAlert("Pattern should not be empty", "error")
            return "";
        }
        if (ldfromdate === undefined || ldfromdate === null || ldfromdate.trim() === "") {
            showAlert("From Date should not be empty", "error")
            return "";
        }
        let loresponse = await CallApi({ method: "get", lookup: "custom/GetRecurrence", params: { pattern: lspattern, from: ldfromdate, to: ldtodate, occurance: lnoccurance }, toa: "ds" });
        if (loresponse.status === true) {
            return loresponse.data;
        } else {
            showAlert(loresponse.errmsg, "error")
            return "";
        }
    } catch (error) {

    }
}

export async function glbAddSterloLog(pojson, pootherinfo) {
    let lobody = {
        "method": "Saving Data",
        "skey": glbGetLocalStorage("logkey"),
        "logmsg": "Saving user Data",
        "objid": null, // Optional
        "addinfo": null // Optional
    }
    let lsurl = pojson.type;
    lobody.logmsg = pojson.message;
    if (pojson.objid) {
        lobody.objid = pojson.objid;
    }
    if (typeof pojson.addinfo === "object") {
        lobody.addinfo = pojson.addinfo;
    }
    if (typeof pootherinfo === "object") {
        if (pootherinfo.objid) {
            lobody.objid = pootherinfo.objid;
        }
        if (typeof pootherinfo.addinfo === "object") {
            lobody.addinfo = pootherinfo.addinfo;
        }
    }
    let loResponse = await CallApi({ method: "post", lookup: lsurl, body: lobody, toa: "sl", skpds: true });
    if (loResponse.status === true) { }
    else {
        showAlert(loResponse.errmsg, 'error');
    }
}
export async function glbHandleDirectCodeEvent(loeventpara) {
    try {
        // glbScreenLoader(true);
        // setTimeout(() => {
        // let lssnippet = 'let lsvalue= refevent.sterGetCtrlProperty(4,"value");showAlert("Selected value is " + lsvalue, "info");return "ok" ';
        let lssnippet = loeventpara.code;
        lssnippet = lssnippet.replaceAll(/GetCtrlProperty/g, "refevent.sterGetCtrlProperty");
        lssnippet = lssnippet.replaceAll(/SetCtrlProperty/g, "refevent.sterSetCtrlProperty");
        lssnippet = lssnippet.replaceAll(/GetGridCtrlProperty/g, "refevent.sterGetGridCtrlProperty");
        lssnippet = lssnippet.replaceAll(/SetGridCtrlProperty/g, "refevent.sterSetGridCtrlProperty");
        if (loeventpara.props !== undefined && loeventpara.props !== null && loeventpara.props !== "") {
            if (loeventpara.props.pid !== undefined && loeventpara.props.pid !== null && loeventpara.props.pid !== "") {
                lssnippet = lssnippet.replaceAll("GetListCtrlProperty(", "refevent.sterGetListCtrlProperty('" + loeventpara.props.pid + "',");
                lssnippet = lssnippet.replaceAll("SetListCtrlProperty(", "refevent.sterSetListCtrlProperty('" + loeventpara.props.pid + "',");
                lssnippet = lssnippet.replaceAll("GetReportCtrlProperty(", "refevent.sterGetReportCtrlProperty('" + loeventpara.props.pid + "',");
                lssnippet = lssnippet.replaceAll("SetReportCtrlProperty(", "refevent.sterSetReportCtrlProperty('" + loeventpara.props.pid + "',");
                lssnippet = lssnippet.replaceAll("SetReportToolbarProperty(", "refevent.sterSetReportToolbarProperty('" + loeventpara.props.pid + "',");
            } else {
                lssnippet = lssnippet.replaceAll("GetListCtrlProperty", "refevent.sterGetListCtrlProperty");
                lssnippet = lssnippet.replaceAll("SetListCtrlProperty", "refevent.sterSetListCtrlProperty");
                lssnippet = lssnippet.replaceAll("GetReportCtrlProperty", "refevent.sterGetReportCtrlProperty");
                lssnippet = lssnippet.replaceAll("SetReportCtrlProperty", "refevent.sterSetReportCtrlProperty");
                lssnippet = lssnippet.replaceAll("SetReportToolbarProperty", "refevent.sterSetReportToolbarProperty");
            }
        } else {
            lssnippet = lssnippet.replaceAll("GetListCtrlProperty", "refevent.sterGetListCtrlProperty");
            lssnippet = lssnippet.replaceAll("SetListCtrlProperty", "refevent.sterSetListCtrlProperty");
            lssnippet = lssnippet.replaceAll("GetReportCtrlProperty", "refevent.sterGetReportCtrlProperty");
            lssnippet = lssnippet.replaceAll("SetReportCtrlProperty", "refevent.sterSetReportCtrlProperty");
            lssnippet = lssnippet.replaceAll("SetReportToolbarProperty", "refevent.sterSetReportToolbarProperty");
        }
        lssnippet = lssnippet.replaceAll(/OpenPage/g, "refevent.sterOpenPage");
        lssnippet = lssnippet.replaceAll(/CallCustomAPI/g, "refevent.sterCallCustomAPI");
        lssnippet = lssnippet.replaceAll(/GetLocalStorage/g, "glbGetLocalStorage");
        lssnippet = lssnippet.replaceAll(/SetLocalStorage/g, "glbSetLocalStorage");
        lssnippet = lssnippet.replaceAll(/ShowAlertDialog/g, "CallConfirmDialog");
        lssnippet = lssnippet.replaceAll(/PrintDocument/g, "refevent.sterPrintDocument");
        lssnippet = lssnippet.replaceAll(/GetGlobalVariable/g, "refevent.sterGetGlobalVariable");
        lssnippet = lssnippet.replaceAll(/SetGlobalVariable/g, "refevent.sterSetGlobalVariable");
        lssnippet = lssnippet.replaceAll(/fnlCallbackHandleEvent/g, "refevent.sterCallbackHandleEvent");
        lssnippet = lssnippet.replaceAll(/RefreshParentPage/g, "refevent.sterRefreshParentPage");
        lssnippet = lssnippet.replaceAll(/RefreshPage/g, "refevent.sterRefreshReport");
        lssnippet = lssnippet.replaceAll(/CallFormEvent/g, "refevent.sterCallFormEvent");
        lssnippet = lssnippet.replaceAll(/OpenDialog/g, "refevent.sterOpenDialog");
        lssnippet = lssnippet.replaceAll(/CallParentControlEvents/g, "refevent.sterCallParentControlEvents");
        lssnippet = lssnippet.replaceAll(/CallControlEvents/g, "refevent.sterCallControlEvents");
        lssnippet = lssnippet.replaceAll(/CallCustomSubmit/g, "refevent.sterCallCustomSubmit");
        lssnippet = lssnippet.replaceAll(/ShowHelpDocument/g, "refevent.sterShowHelpDocument");
        lssnippet = lssnippet.replaceAll(/AutoFillFromDataSource/g, "refevent.sterAutoFillFromDataSource");
        lssnippet = lssnippet.replaceAll(/CallAIService/g, "refevent.sterCallAIService");
        lssnippet = lssnippet.replaceAll(/ShowInPopup/g, "refevent.sterShowInPopup");
        lssnippet = lssnippet.replaceAll(/CallbackSaveTask/g, "refevent.sterCallbackSaveTask");
        lssnippet = lssnippet.replaceAll(/ControlsValidaton/g, "refevent.sterControlsValidaton");
        lssnippet = lssnippet.replaceAll(/ChangeWorkflowProcess/g, "refevent.sterChangeWorkflowProcess");
        lssnippet = lssnippet.replaceAll(/SaveCustomTask/g, "refevent.sterSaveCustomTask");
        lssnippet = lssnippet.replaceAll(/LoadAnotherScreen/g, "refevent.sterLoadAnotherScreen");
        lssnippet = lssnippet.replaceAll(/OpenNewTab/g, "refevent.sterOpenNewTab");
        lssnippet = lssnippet.replaceAll(/OpenIFrame/g, "refevent.sterOpenIFrame");
        lssnippet = lssnippet.replaceAll(/SetLoading/g, "glbScreenLoader");
        lssnippet = lssnippet.replaceAll(/ConsoleLog/g, "glbConsoleLog");
        lssnippet = lssnippet.replaceAll(/UpdateTokenInfo/g, "glbUpdateTokenInfo");
        lssnippet = lssnippet.replaceAll(/ChangeLanguage/g, "refevent.sterChangeLanguage");
        lssnippet = lssnippet.replaceAll(/ExportHTMLToExcel/g, "refevent.sterExportHTMLToExcel");
        if (loeventpara.callback !== undefined) {
            //lssnippet = "eval(ls)";
            lssnippet = "try {\n" + lssnippet;
            lssnippet += "\n}catch(err){ ";
            lssnippet += "\nconsole.log(err);";
            // lssnippet += "\nshowAlert(err, 'info')";
            lssnippet += "\n CallConfirmDialog('info', err);"
            lssnippet += "\nglbScreenLoader(false);\nreturn false;}";
        }
        let loglobalvariable = glbGetLocalStorage("globalvariable");
        if (loeventpara.props !== "" && loeventpara.props !== undefined && loeventpara.props !== null) {
            if (loeventpara.props.ctrleventtype !== "" && loeventpara.props.ctrleventtype !== undefined && loeventpara.props.ctrleventtype !== null) {
                if (loeventpara.props.ctrleventtype === "Grid" && loeventpara.props.mode !== "" && loeventpara.props.mode !== undefined && loeventpara.props.mode !== null) {
                    loeventpara.mode = String(loeventpara.props.mode).toLocaleLowerCase();
                }
            }
        }
        let args = {
            refevent: loeventpara.event,
            showAlert: showAlert,
            CallApi: CallApi,
            glbGetLocalStorage: glbGetLocalStorage,
            glbSetLocalStorage: glbSetLocalStorage,
            CallConfirmDialog: CallConfirmDialog,
            glbScreenLoader: glbScreenLoader,
            glbConsoleLog: glbConsoleLog,
            IsApplicableRoles: glbHasApplicableRoles,
            GetDate: glbGetDate,
            GeoLocation: getGeoLocation,
            GetScheduleRecurrence: glbGetScheduleRecurrence,
            Print: glbBluetoothPrint,
            AddSterloLog: glbAddSterloLog,
            GetFileFromStorage: fnGetFileFromStorage,
            GetNewFolderData: glbGetFolderFromStorage,
            glbUpdateTokenInfo: glbUpdateTokenInfo,
            mode: loeventpara.mode,
            primarykeyvalue: loeventpara.primarykeyvalue,
            globalvariable: loglobalvariable,
            drilldowninfo: loeventpara.drilldowninfo,
            screeninfo: loeventpara.screeninfo,
            propsinfo: loeventpara.props,
            source: loeventpara.source,
            keyevents: loeventpara.keyevents,
            SaveValidation: loeventpara.savevalidation,
            selecteddata: loeventpara.selecteddata,
            eventtype: loeventpara.eventtype,
            onCustomCallBack: loeventpara.onCustomCallBack,
            approvaltype: loeventpara.approvaltype
        };
        let wrappedSnippet = `
            return (async () => {
                ${lssnippet}
            })();
        `;
        let fn = Function.apply(Function, Object.keys(args).concat(wrappedSnippet));
        let lsreturnvalue = await fn.apply(fn, Object.keys(args).map(key => args[key]));
        // glbScreenLoader(false);
        if (loeventpara.callback !== undefined) {
            loeventpara.callback(lsreturnvalue);
        }
        return lsreturnvalue;
        // }, 100);
    }
    catch (err) {
        glbScreenLoader(false);
        console.log("Direct Code Event Error", err);
        return false;
    }
}
export function glbConsoleLog(pslog) {
    console.log(pslog);
}
export async function glbCheckListDataConversion(pdTranData, pdConfigData) {
    let ldArrResult = []
    let ldTranData = pdTranData;
    if (typeof (ldTranData) === "string") {
        ldTranData = JSON.parse(ldTranData);
    }
    if (pdTranData.length > 0 && pdConfigData.length > 0) {
        let loarrColJson = {}
        for (let colno = 0; colno < pdConfigData.length; colno++) {
            loarrColJson[pdConfigData[colno].okey] = pdConfigData[colno].nkey;
        }
        for (let rowno = 0; rowno < pdTranData.length; rowno++) {
            const keyValues = Object.keys(pdTranData[rowno]).map(key => {
                const newKey = loarrColJson[key];
                if (newKey !== undefined && newKey !== null && newKey != "") {
                    return { [newKey]: pdTranData[rowno][key] };
                } else {
                    return { [key]: pdTranData[rowno][key] };
                }
            });
            ldArrResult.push(Object.assign({}, ...keyValues));
        }
    }
    return ldArrResult;
}
export function fnlCapitalize(string) {
    try {
        return string.charAt(0).toUpperCase() + string.slice(1)
    }
    catch (err) {
        console.log("Captialize method error", err);
    }

}
export function glblGetTimeZone() {
    try {
        let lstimezone = new Intl.DateTimeFormat('en', { timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone }).resolvedOptions().timeZone;
        if (lstimezone === "Asia/Calcutta") {
            lstimezone = "Asia/Kolkata";
        }
        return lstimezone;
    }
    catch (err) {
        console.log("TimeZone error", err);
        return "";
    }
}
export function glbGetDate(psdate) {
    try {
        let lddate = "";
        let lstimezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
        // lstimezone = 'Asia/Calcutta';
        if (psdate === undefined) {
            lddate = new Date(new Date().toLocaleString('en', { timeZone: lstimezone }));
            return lddate;
        }
        else if (glbHasValues(psdate) && glbCheckValidDate(psdate, 'noformat')) {
            if (typeof psdate === "string") {
                let lsdatesplit = psdate.includes("-") ? psdate.split("-") : psdate.split("/");
                if (lsdatesplit.length === 3 && lsdatesplit[2].trim().length < 3) {
                    psdate = psdate + " 00:00";
                }
            }
            lddate = new Date(new Date(psdate).toLocaleString('en', { timeZone: lstimezone }));
            return lddate;
        }
        else {
            try {
                if (typeof psdate === "number" && psdate.toString().length > 10) {
                    return new Date(psdate);
                }
            }
            catch (err) {
                return "";
            }
        }
        return "";
    }
    catch (err) {
        console.log("getDate error", err);
        return "";
    }
}
export function glbGetDataTypeValues(psval) {
    try {
        let lsResult = 'string';
        let loAllDataType = [{ "dtype": "VARCHAR", "ndtype": "string" }, { "dtype": "INT", "ndtype": "number" }, { "dtype": "FLOAT", "ndtype": "string" }, { "dtype": "DOUBLE", "ndtype": "string" }, { "dtype": "DECIMAL", "ndtype": "number" }, { "dtype": "DATETIME", "ndtype": "datetime" }, { "dtype": "DATETIMEOFFSET", "ndtype": "datetime" }, { "dtype": "BLOB", "ndtype": "string" }, { "dtype": "JSON", "ndtype": "string" }, { "dtype": "NVARCHAR", "ndtype": "string" }, { "dtype": "BIT", "ndtype": "string" }, { "dtype": "SMALLINT", "ndtype": "string" }, { "dtype": "DATE", "ndtype": "date" }]
        let loFlter = loAllDataType.filter(e => e.dtype.toLowerCase() === psval);
        if (loFlter.length > 0) {
            lsResult = loFlter[0].ndtype;
        }
        return lsResult;
    }
    catch (err) {
        console.log("Set GlobalVariable", err);
        return "";
    }
}
export function glblCheckGlobalVariable(psvariable) {
    try {
        if (typeof psvariable === "string" && psvariable.substring(0, 2) === "$$") {
            psvariable = psvariable.substring(2, psvariable.length);
        }
        let loglobalvariable = glbGetLocalStorage("globalvariable");
        if (loglobalvariable[psvariable] !== undefined) {
            return true;
        }
        else {
            return false;
        }
    }
    catch (err) {
        console.log("Check GlobalVariable", err);
        return false;
    }
}
export function glblGetGlobalVariable(psvariable) {
    try {
        if (typeof psvariable === "string" && psvariable.substring(0, 2) === "$$") {
            psvariable = psvariable.substring(2, psvariable.length);
        }
        let loglobalvariable = glbGetLocalStorage("globalvariable");
        if (loglobalvariable[psvariable] !== undefined) {
            return loglobalvariable[psvariable];
        }
        else {
            return "";
        }
    }
    catch (err) {
        console.log("Get GlobalVariable", err);
        return "";
    }
}
export function glblSetGlobalVariable(psvariable, psvalue) {
    try {
        if (typeof psvariable === "string" && psvariable.substring(0, 2) === "$$") {
            psvariable = psvariable.substring(2, psvariable.length);
        }
        let loglobalvariable = glbGetLocalStorage("globalvariable");
        loglobalvariable[psvariable] = psvalue;
        glbSetLocalStorage("globalvariable", loglobalvariable);
    }
    catch (err) {
        console.log("Set GlobalVariable", err);
        return "";
    }
}
export async function glbSubmitData(podata) {
    refScrLocalVariables.current.ScrloDesignData2 = podata.ControlList;
    refScrLocalVariables.current.ScrloControlOrder = podata.ControlList;
    refScrLocalVariables.current.ScrloCustomProps = podata.ControlProps;
    refScrLocalVariables.current.ScrlsDtsetRef = podata.ScrLocalVariables.ScrlsDtsetRef
    refScrLocalVariables.current.ScrlsDtsetName = podata.ScrLocalVariables.ScrlsDtsetName
    refScrLocalVariables.current.ScrlsDtSetTcd = podata.ScrLocalVariables.ScrlsDtSetTcd
    refScrLocalVariables.current.ScrlsPrimaryKey = podata.ScrLocalVariables.ScrlsPrimaryKey
    refScrLocalVariables.current.ScrloTaskHeader = podata.ScrloTaskHeader
    refSterContols.current = podata.refSterControls;
    refScrLocalVariables.current.ScrloModifiedDatajson = podata.ScrloModifiedDatajson
    let laaValidationdata = glbSaveValidation();
    let loResponseSubmit;
    if (laaValidationdata === false) {
        showAlert("Please Fill Mandatory Fields !", 'info');
        return;
    }
    else {
        let lbhtmlinjectionfound = await glbGetModifiedSaveJson(refScrLocalVariables);
        if (lbhtmlinjectionfound === false) {
            loResponseSubmit = await glbUpdateScreenData();
            loResponseSubmit['modifiedJson'] = refScrLocalVariables.current.ScrloModifiedDatajson
            return loResponseSubmit
        }
    }
}
function glbSaveValidation(pstabinfo, psid, pschildid, poaddinfo) {
    let lbvalidsuccess = true, lbcustomvalidsuccess = true;
    refScrLocalVariables.current.ScrLoErrorMessage = [];
    let ldScrlDesignData = [];
    if (pstabinfo === "tab") {
        if (psid !== undefined && psid !== null && psid !== "" && pschildid !== undefined && pschildid !== null && pschildid !== "") {
            let ldDesignData = JSON.parse(refDesignData.current.designdata.data.design6);
            let ldFilterTabID = ldDesignData.filter(x => x.crntID === psid);
            if (ldFilterTabID.length > 0) {
                if (ldFilterTabID[0].Children.length > 0) {
                    let ldFilterChildTabID = ldFilterTabID[0].Children.filter(x => x.TabID === pschildid);
                    if (ldFilterChildTabID.length > 0) {
                        ldScrlDesignData = ldFilterChildTabID[0].Tabdet;
                    }
                }
            }
        }
    } else {
        ldScrlDesignData = refScrLocalVariables.current.ScrloDesignData2;
    }
    ldScrlDesignData = ldScrlDesignData.filter((ldScrlDesignData, index, self) =>
        index === self.findIndex((t) => (t.crntID === ldScrlDesignData.crntID)))
    ldScrlDesignData.forEach((item) => {
        let lspropscustom = refScrLocalVariables.current.ScrloCustomProps[item.crntID];
        if (lspropscustom !== undefined && lspropscustom !== null && lspropscustom !== "") {
            if (pstabinfo === "nobindfield" || (lspropscustom.hasOwnProperty("bindfield") && lspropscustom.bindfield !== "" && lspropscustom.bindfield !== undefined && lspropscustom.bindfield !== null)) {
                let lbrequired = refScrLocalVariables.current.ScrloCustomProps[item.crntID].required;
                let lbistabcontrol = false;
                if (lbrequired === true && typeof refScrLocalVariables.current.ScrloCustomProps[item.ChildID] === "object" && refScrLocalVariables.current.ScrloCustomProps[item.ChildID].ctrlcode === "WFC101") {
                    lbistabcontrol = true;
                }
                if ((refSterContols.current.hasOwnProperty(item.crntID) && lbrequired === true) || (lspropscustom.ctrlcode == 'WFC103' || lspropscustom.ctrlcode == "WFC108")) {
                    if (refSterContols.current[item.crntID] !== undefined && refSterContols.current[item.crntID] !== null && refSterContols.current[item.crntID] !== "" && refSterContols.current[item.crntID].hasOwnProperty("validateFunction")) {
                        let lbreturnvalue = true;
                        if (pstabinfo === "nobindfield" && poaddinfo !== undefined && poaddinfo !== null && typeof poaddinfo === "object" && poaddinfo.isfirsttimeload === true) {
                            lbreturnvalue = glbMandatoryValid(lspropscustom["value"], lspropscustom);
                        }
                        else {
                            if (lspropscustom.ctrlcode == 'WFC016' || lspropscustom.ctrlcode == "WFC108") {
                                lbreturnvalue = refSterContols.current[item.crntID].validateFunction('', '', refdraftsave.current);
                            } else {
                                lbreturnvalue = refSterContols.current[item.crntID].validateFunction('');
                            }
                        }
                        if (lbreturnvalue === false) {
                            lbvalidsuccess = false;
                        }
                        else if (typeof lbreturnvalue === "object" && lbreturnvalue.hasOwnProperty("status") && lbreturnvalue.status === false) {
                            refScrLocalVariables.current.ScrLoErrorMessage.push(lbreturnvalue);
                            lbvalidsuccess = false;
                            if (lbreturnvalue.hasOwnProperty("type") && lbreturnvalue.type === "custom" && refdraftsave.current === "") {
                                lbvalidsuccess = true;
                            } else if (lbreturnvalue.hasOwnProperty("type") && lbreturnvalue.type === "custom" && lbreturnvalue.draftsave === true && refdraftsave.current === "draftsave") {
                                lbvalidsuccess = true;
                                refScrLocalVariables.current.ScrLoErrorMessage = [];
                            }
                        }
                    }
                    else {
                        console.log("No validateFunction");
                        console.log(item);
                    }
                }
                else if (lbistabcontrol === true) {
                    lbvalidsuccess = false;
                }
                //don't uncomment this code for future reference
                // else if (refSterContols.current.hasOwnProperty(item.crntID) === false && lbrequired === true) {
                //     lbvalidsuccess = false;
                // }
                /*if (lspropscustom.cvalidate !== '' && lspropscustom.cvalidate !== undefined && lspropscustom.cvalidate !== '') {
                    let lsflag = fnlCustomValidate(lspropscustom);
                    if (lsflag === false) {
                        // lbvalidsuccess = false;
                        lbcustomvalidsuccess = false;
                    }
                }*/
            }
        }
    });
    if (lbvalidsuccess === true) {
        let lbvalidationdata = glbHandleValidation()
        if (lbvalidationdata === false) {
            return 0;
        }
        if (lbcustomvalidsuccess === false) {
            return "custom";
        }
    }
    return lbvalidsuccess;
}
const glbHandleValidation = (refSterContols) => {
    var validations = [{
        "id": 1,
        "expcode": "EXP001",
        "expdesc": "Mandatory",
        "expmsg": "Please fill mandatory field",
        "expname": "mandatory",
        "expression": "[^ ]",
        "actstatus": true,
        "selected": false,
        "isdisabled": true
    },
    {
        "id": 2,
        "expcode": "EXP002",
        "expdesc": "Phone number validation",
        "expmsg": "Please check the mobile no",
        "expname": "phoneNumValidation",
        "expression": "^[0-9]{10}$",
        "actstatus": true,
        "selected": false,
        "isdisabled": true
    },
    {
        "id": 3,
        "expcode": "EXP003",
        "expdesc": "Email validation",
        "expmsg": "Please check the email",
        "expname": "emailValidation",
        "expression": "^[a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+\\.[a-zA-Z0-9-.]+$",
        "actstatus": true,
        "selected": false,
        "isdisabled": true
    }];

    var validationMessages = [];
    if (refScrLocalVariables.current.ScrloControlOrder !== undefined && refScrLocalVariables.current.ScrloControlOrder !== null && refScrLocalVariables.current.ScrloControlOrder !== "") {
        refScrLocalVariables.current.ScrloControlOrder.forEach((data) => {
            //"WFC026"
            //Handled for Datatable validaton function
            if (data.ctrlCode === "WFC026") {
                if (data.props.custom.hasOwnProperty('columns')) {
                    if (data.props.custom.columns !== '' && typeof data.props.custom.columns === 'string') {
                        let lovalcap = JSON.parse(data.props.custom.columns)
                        lovalcap = lovalcap.filter((i) => i['cvalidate'] !== undefined && i['cvalidate'] !== null && i['cvalidate'] !== '')
                        // let loexpcap=[];
                        if (lovalcap.length > 0) {
                            let lodata = refSterContols.current[data.props.custom.id].currentViewData;
                            let i = 0, len = lodata.length;
                            if (Array.isArray(refExpdata.current.expdata) && refExpdata.current.expdata.length > 0) {
                                for (i; i < len; i++) {
                                    for (let j = 0; lovalcap.length > j; j++) {
                                        if (lovalcap[j]['cvalidate'].includes('EXP') == true && lovalcap[j]['cvalidate'].includes('{') == false) {
                                            let matchedVal = refExpdata.current.expdata.filter((val) => { return val.expcode === lovalcap[j]['cvalidate'] });
                                            if (matchedVal.length > 0) {
                                                let value = lodata[i][lovalcap[j]['datafield']];//lovalcap[j].datafield
                                                if (value !== undefined && value !== null && value !== '') {
                                                    let _exprsion = new RegExp(matchedVal[0].exprsion);
                                                    if (value.match(_exprsion) === null) {
                                                        validationMessages.push(matchedVal[0].expmsg);
                                                    }
                                                }

                                            }
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }
            if (data.props.custom.validation !== "" && data.props.custom.validation !== undefined) {
                let validation = data.props.custom.validation;
                if (validation !== undefined) {
                    let validationCodes = validation.split(',');
                    if (validationCodes.length > 0) {
                        validationCodes.forEach((code) => {
                            //Temporarily this code added for old screen validation by ORE049
                            if (Array.isArray(refExpdata.current.expdata) && refExpdata.current.expdata.length > 0) {
                                //Temporarily this code added for old screen validation by ORE049
                                if (code === 'EXP002') { code = 'EXP0001' } else if (code === 'EXP003') { code = 'EXP0006' }
                                //------
                                let matchedVal = refExpdata.current.expdata.filter((val) => { return val.expcode === code });
                                if (matchedVal.length > 0) {
                                    //email validation trim
                                    let value = refSterContols.current[data.props.custom.id].value.trim();
                                    //-----
                                    if (value !== undefined && value !== null && value !== '') {
                                        let _exprsion = new RegExp(matchedVal[0].exprsion);
                                        if (value.match(_exprsion) === null) {
                                            validationMessages.push(matchedVal[0].expmsg);
                                        }
                                    }

                                }

                            }
                            else {

                                let matchedVal = validations.filter((o) => o.expcode === code)
                                if (matchedVal.length > 0) {
                                    let value = refSterContols.current[data.props.custom.id].value.trim();
                                    if (value !== undefined && value !== null && value !== '') {
                                        let _exprsion = new RegExp(matchedVal[0].expression);
                                        if (value.match(_exprsion) === null) {
                                            validationMessages.push(matchedVal[0].expmsg);
                                        }
                                    }

                                }


                            }
                        })
                    }
                }
            }
        });
    }
    if (validationMessages.length > 0) {
        validationMessages.forEach((data) => {
            showAlert(data, 'error');
        });
        return false;
    }
}
function glbGetModifiedSaveJson(refScrLocalVariables) {
    try {
        let lbhtmlinjectionfound = false;
        refScrLocalVariables.current.ScrloControlOrder.forEach((item) => {
            let lspropscustom = item.props.custom;
            if (item.ctrlCode === "WFC011" && refScrLocalVariables.current.ScrloCustomProps[item.crntID] !== undefined) {
                lspropscustom = refScrLocalVariables.current.ScrloCustomProps[item.crntID];
            }
            if (lbhtmlinjectionfound === false && typeof lspropscustom === "object" && lspropscustom.hasOwnProperty("bindfield") && lspropscustom.bindfield !== "" && lspropscustom.bindfield !== undefined && lspropscustom.bindfield !== null) {
                if (refSterContols.current.hasOwnProperty(item.crntID) && refSterContols.current[item.crntID] !== null && refSterContols.current[item.crntID] !== undefined && refSterContols.current[item.crntID].hasOwnProperty("fnlGetCtrlProperty")) {
                    let lssavevalue = "";
                    if (refapprovereject.current == 130 && item.ctrlCode === "WFC016") {
                        lssavevalue = refSterContols.current[item.crntID].fnlGetCtrlProperty("value", { "prname": "Rejected" });
                    }
                    else {
                        lssavevalue = refSterContols.current[item.crntID].fnlGetCtrlProperty("value");
                    }
                    if (glbHTMLInjectionFound(lssavevalue) && item.ctrlCode !== "WFC020" && item.ctrlCode !== "WFC108") {
                        lbhtmlinjectionfound = true;
                        showAlert(lspropscustom.caption + ' should not contain the HTML tags', 'error');
                        glbScreenLoader(false);
                        glbShowProgressSubmitButton(false);
                    }
                    else if (item.ctrlCode === "WFC011" && lspropscustom.autodoc !== "Yes" && lspropscustom.multiline !== true && lspropscustom.alwsplchar !== true && lspropscustom.alwsplchar !== "true" && lssavevalue !== "" && lssavevalue !== undefined && lssavevalue !== null && glbValidSpecialCharacters(lssavevalue)) {
                        lbhtmlinjectionfound = true;
                        showAlert(lspropscustom.caption + ' should not contain the Special Characters', 'error');
                        glbScreenLoader(false);
                        glbShowProgressSubmitButton(false);
                    }
                    else {
                        if (refScrLocalVariables.current.hasOwnProperty("ScrloTaskHeader") && lssavevalue !== "" && lssavevalue !== undefined && lssavevalue !== null && lspropscustom.bindfield === refScrLocalVariables.current.ScrloTaskHeader.trgtdtfld) {
                            refScrLocalVariables.current.ScrloTaskHeader.targetdt = lssavevalue;
                        }
                        let lbalwchangeassignee = true;
                        if (refDesignData.current.istask === true && typeof refScrLocalVariables.current.ScrloTaskHeader === "object" && refScrLocalVariables.current.ScrloTaskHeader.trigrtyp === 10) {
                            if (typeof refScrLocalVariables.current.ScrloLinkInfo === "object" && refScrLocalVariables.current.ScrloLinkInfo !== null && typeof refScrLocalVariables.current.ScrloLinkInfo.lnkdetail === "object" && refScrLocalVariables.current.ScrloLinkInfo.lnkdetail !== null) {
                                let lofilterdata = refScrLocalVariables.current.ScrloLinkInfo.lnkdetail.filter(x => x.tgtfld === "#assignto" && x.srcfld == item.crntID);
                                if (lofilterdata.length > 0 && lofilterdata[0].alwchange == 20) {
                                    lbalwchangeassignee = false;
                                }
                            }
                        }
                        if (lbalwchangeassignee === true) {
                            refScrLocalVariables.current.ScrloModifiedDatajson[lspropscustom.bindfield] = lssavevalue;
                        }
                    }
                }
                else {
                    console.log("Deleted Control Properties not removed");
                    console.log(item);
                }

            }
        });
        return lbhtmlinjectionfound;
    }
    catch (err) {
        CallConfirmDialog("warning", err);
        glbScreenLoader(false);
        glbShowProgressSubmitButton(false);
        return true;
    }
}
export async function glbUpdateScreenData() {
    const tctappstore = glbGetLocalStorage("ssUserData");
    try {
        // let refScrLocalVariables = { current: {} };
        let lbisdocnogenerate = false;
        refScrLocalVariables.current.ScrloTempModifiedDatajson = {};
        let lsurl = "dpcrud";
        if (refScrLocalVariables.current.ScrloModifiedDatajson[refScrLocalVariables.current.ScrlsPrimaryKey] > 0 || glbHasValues(refScrLocalVariables.current.ScrloModifiedDatajson[refScrLocalVariables.current.ScrlsPrimaryKey])) {
            lsurl = "dpcrud/LogicalUpdate";
            refScrLocalVariables.current.ScrloModifiedDatajson.creusrid = tctappstore.usercode;
            /*let loappmapjson = { 120: "A", 160: "A", 130: "R", 170: "S" }
            if (loappmapjson[pnapprovereject] !== undefined && refScrLocalVariables.current.ScrloDocNoGenerationOn !== undefined && refScrLocalVariables.current.ScrloDocNoGenerationOn !== null && typeof refScrLocalVariables.current.ScrloDocNoGenerationOn === "object") {
                if (typeof refScrLocalVariables.current.ScrloDocNoGenerationOn.docnogenon === "string") {
                    if (refScrLocalVariables.current.ScrloDocNoGenerationOn.docnogenon.split(",").indexOf(loappmapjson[pnapprovereject]) !== -1) {
                        lbisdocnogenerate = true;
                    }
                }
            }*/
        }
        else {
            lbisdocnogenerate = true;
            let psdoccode = "{}";
            let lardocno = refScrLocalVariables.current.ScrloDesignData2.filter(x => x.props.custom.rdoccode != undefined && x.props.custom.rdoccode != "" && x.props.custom.rdoccode != null)
            if (lardocno.length > 0) {
                psdoccode = lardocno[0].props.custom.rdoccode;
            }
            else {
                lardocno = refScrLocalVariables.current.ScrloDesignData2.filter(x => x.props.custom.doccode != undefined && x.props.custom.doccode != "" && x.props.custom.doccode != null);
                if (lardocno.length > 0) {
                    psdoccode = lardocno[0].props.custom.doccode;
                }
            }
            if (lardocno.length > 0) {
                let lodocjson = '';
                try {
                    lodocjson = JSON.parse(psdoccode);
                    if (lodocjson.gtype === "T") {
                        lbisdocnogenerate = false;
                    }
                }
                catch {

                }
            }
            const lspstuuid = uuidv1();
            refScrLocalVariables.current.ScrloModifiedDatajson.tuuid = lspstuuid;
            refScrLocalVariables.current.ScrloModifiedDatajson.creusrid = tctappstore.usercode;
            refScrLocalVariables.current.ScrloModifiedDatajson.tcd = tctappstore.tcd;
            if (refdraftsave.current === "draftsave") {
                refScrLocalVariables.current.ScrloModifiedDatajson.appstat = 30;
            }
        }
        //Document Number Config
        if (lbisdocnogenerate === true) {
            let lndocno = '', lsdocbindfield = '';
            let lodocfilter = refScrLocalVariables.current.ScrloDesignData2.filter(x => x.props.custom.rdoccode != undefined && x.props.custom.rdoccode != "" && x.props.custom.rdoccode != null)
            if (lodocfilter.length === 0) {
                lodocfilter = refScrLocalVariables.current.ScrloDesignData2.filter(x => x.props.custom.doccode != undefined && x.props.custom.doccode != "" && x.props.custom.doccode != null)
            }
            for (let i = 0; i < lodocfilter.length; i++) {
                let lodocjson = await glbOnSaveDocNo(1, lodocfilter[i]);
                if (typeof lodocjson === "object" && lodocjson.hasOwnProperty("status") && lodocjson.status === false) {
                    CallConfirmDialog("warning", lodocjson.errmsg);
                    glbShowProgressSubmitButton(false);
                    glbScreenLoader(false);
                    return;
                }
                else {
                    if (lodocjson !== undefined && lodocjson.length > 0) {
                        lndocno = lodocjson[0].props.custom.value;
                        lsdocbindfield = lodocjson[0].props.custom.bindfield;
                        refSterContols.current[lodocjson[0].props.custom.id].value = lndocno;
                        refScrLocalVariables.current.ScrloModifiedDatajson[lsdocbindfield] = lndocno;
                        refScrLocalVariables.current.ScrloTempModifiedDatajson = refScrLocalVariables.current.ScrloModifiedDatajson;
                    }
                }
            }
        }

        let lobody = {};
        lobody.id = refScrLocalVariables.current.ScrlsDtsetRef;
        lobody.alias = refScrLocalVariables.current.ScrlsDtsetName;
        lobody.tcd = refScrLocalVariables.current.ScrlsDtSetTcd;
        lobody.ver = -1;
        lobody.lparams = refScrLocalVariables.current.ScrloModifiedDatajson;
        console.log(lobody);
        let loResponse = await CallApi({ method: "post", lookup: lsurl, body: lobody, toa: "d", });
        return loResponse;
    }
    catch (err) {
        CallConfirmDialog("warning", err);
        glbShowProgressSubmitButton(false);
        glbScreenLoader(false);
    }
}
//Document No Generation Start
async function glbOnSaveDocNo(pnmode, podocfilter) {
    let lndocno = '';
    //new Document Generation for rdoccode
    let loDesignData2 = JSON.parse(JSON.stringify(refScrLocalVariables.current.ScrloDesignData2));
    let lardocno = loDesignData2.filter(x => x.props.custom.rdoccode != undefined && x.props.custom.rdoccode != "" && x.props.custom.rdoccode != null && x.props.custom.id == podocfilter.props.custom.id)
    if (lardocno.length > 0 && lardocno[0].props.custom.autodoc !== 'No' && JSON.parse(lardocno[0].props.custom.rdoccode).type !== "CONFIG") {
        let psdoccode = lardocno[0].props.custom.rdoccode;
        let lodocjson = '';
        let lsdoctype = '';
        let loaddInfo = []
        try {
            if (typeof psdoccode === "object") {
                lodocjson = psdoccode;
            }
            else {
                lodocjson = JSON.parse(psdoccode);
            }
            psdoccode = lodocjson.rdoccode;
            lsdoctype = lodocjson.reseton;
            lodocjson = JSON.stringify(lodocjson);
            let addsinfo = {}
            loaddInfo.push(addsinfo)
            loaddInfo = JSON.stringify(loaddInfo)

        }
        catch {

        }
        let locontrolid = [];
        let loResponse = await CallApi({ method: "get", lookup: "dpcrud/GetDocumentNo", "params": "docID=" + lodocjson + "&mode=" + pnmode + "&lparams=" + loaddInfo, toa: "d" });
        loResponse.locontrolid = locontrolid;
        if (loResponse.status == true) {
            lndocno = loResponse.data;
            lardocno[0].props.custom.value = lndocno;;
        }
        else {
            return loResponse;
        }
        return await lardocno;
    }
    else {
        let loavaidocno = [];
        let psdoccode = '';
        if (lardocno.length > 0) {
            loavaidocno = lardocno;
            psdoccode = lardocno[0].props.custom.rdoccode;
        }
        else {
            loavaidocno = loDesignData2.filter(x => x.props.custom.doccode != undefined && x.props.custom.doccode != "" && x.props.custom.doccode != null && x.props.custom.id == podocfilter.props.custom.id);
            psdoccode = loavaidocno[0].props.custom.doccode;
        }
        if (loavaidocno.length > 0 && loavaidocno[0].props.custom.autodoc !== "No") {
            let lodocjson = '';
            let lsdoctype = '';
            if (loavaidocno.length > 0) {
                try {
                    if (typeof psdoccode === "object") {
                        lodocjson = psdoccode;
                    }
                    else {
                        lodocjson = JSON.parse(psdoccode);
                    }
                    psdoccode = lodocjson.doccode;
                    lsdoctype = lodocjson.reseton;
                }
                catch {

                }
                if (typeof lodocjson === "object") {
                    let loResponse = await fnlNewDocumentNoCreate(lodocjson, pnmode, '');
                    if (loResponse.status == true) {
                        lndocno = loResponse.data;
                    }
                    else {
                        return loResponse;
                    }
                }
                else {
                    let lodocconfig = [], lsprefix = '', lssuffix = '';
                    let loResponseconfig = await fnlScreenDocumentNoCreate(psdoccode);
                    if (loResponseconfig.status == true) {
                        lodocconfig = loResponseconfig.data;
                        if (lodocconfig.length > 0) {
                            lsdoctype = lodocconfig[0].doctype;
                            lssuffix = lodocconfig[0].suffix;
                            if (lodocconfig[0].disformat !== "" && lodocconfig[0].disformat !== undefined && lodocconfig[0].disformat !== null) {
                                lsprefix = lodocconfig[0].disformat.replaceAll('<DOC>', '');
                                if (lsprefix.includes("<CV~projcode>")) {
                                    lsprefix = lsprefix.replaceAll('<CV~projcode>', '<ctrlid~3~projcode>');
                                }
                            }
                        }
                    }
                    lodocjson = { "type": "DIRECT", "doccode": psdoccode, "reseton": lsdoctype, "prefix": lsprefix, "suffix": lssuffix, "length": "4", "mode": "OnLoad" };
                    let loResponse = await fnlNewDocumentNoCreate(lodocjson, pnmode);
                    if (loResponse.status == true) {
                        lndocno = loResponse.data;
                    }
                    else {
                        return loResponse;
                    }

                }
            }
        }
        if (loavaidocno.length > 0) {
            loavaidocno[0].props.custom.value = lndocno;
        }
        return loavaidocno;
    }
}
function glbShowProgressSubmitButton() {

}
export function glbHasValues(psvalue) {
    if (psvalue !== "" && psvalue !== undefined && psvalue !== null && psvalue != 0 && String(psvalue).trim() !== "") {
        return true;
    }
    else {
        return false;
    }
}
export function glbCheckValidDate(psvalue, psformat) {
    let lddate = "", lbvalue = true;
    if (glbHasValues(psvalue)) {
        if (typeof psvalue === "string" && ((psvalue.split("/").length === 3 || psvalue.split("-").length === 3) || psformat === "noformat")) {
            lddate = new Date(psvalue);
        }
        else if (typeof psvalue === "object") {
            lddate = psvalue;
        }
        lbvalue = lddate instanceof Date && !isNaN(lddate.valueOf());
        if (lbvalue === true && psformat !== "noformat" && typeof psformat === "string" && psformat !== "" && typeof psvalue === "string") {
            let lsformatsplit = psformat.includes('/') ? psformat.split('/') : psformat.split('-');
            let lsvaluesplit = psvalue.includes('/') ? psvalue.split('/') : psvalue.split('-');
            if (lsvaluesplit[0].length != lsformatsplit[0].length || lsvaluesplit[1].length != lsformatsplit[1].length || lsvaluesplit[2].length !== lsformatsplit[2].length) {
                lbvalue = false
            }
        }
    }
    return lbvalue;
}
export function glbGetDataType(psval) {
    try {
        let loFinalResult = [];
        let loFlterdVal = [];
        if (psval !== '') {
            loFlterdVal = psval.split(',');
        }
        let loglbjsonData = [
            { "name": "Varchar", "code": "varchar", "order": 0, "size": true, "presion": false, "verno": 1, "defval": "250", "dtype": "String", "required": false },
            { "name": "Int", "code": "int", "order": 1, "size": false, "presion": false, "verno": 1, "defval": "", "dtype": "Number", "required": false },
            { "name": "Float", "code": "float", "order": 2, "size": false, "presion": false, "verno": 1, "defval": "", "dtype": "Number", "required": false },
            { "name": "Double", "code": "double", "order": 3, "size": false, "presion": false, "verno": 1, "defval": "", "dtype": "Number", "required": false },
            { "name": "Decimal", "code": "decimal", "order": 4, "size": true, "presion": true, "verno": 1, "defval": "18", "dtype": "Number", "required": false },
            { "name": "Datetime", "code": "datetime", "order": 5, "size": false, "presion": false, "verno": 2, "defval": "", "dtype": "Date Time", "required": false },
            { "name": "Datetimeoffset", "code": "datatimeeoffset", "order": 6, "size": false, "presion": false, "verno": 1, "defval": "", "dtype": "Date Time", "required": false },
            { "name": "BLOB", "code": "blob", "order": 7, "size": true, "presion": false, "verno": 1, "defval": "", "dtype": "String", "required": false },
            { "name": "JSON", "code": "json", "order": 8, "size": true, "presion": false, "verno": 1, "defval": "", "dtype": "JSON", "required": false },
            { "name": "Nvarchar", "code": "nvarchar", "order": 9, "size": true, "presion": false, "verno": 1, "defval": "1000", "dtype": "String", "required": false },
            { "name": "Bit", "code": "bit", "order": 10, "size": false, "presion": false, "verno": 1, "defval": "", "dtype": "Number", "required": false },
            { "name": "Smallint", "code": "smallint", "order": 11, "size": false, "presion": false, "verno": 1, "defval": "", "dtype": "Number", "required": false },
            { "name": "Date", "code": "date", "order": 12, "size": false, "presion": false, "verno": 2, "defval": "", "dtype": "String", "required": false },
            { "name": "DetailTable", "code": "detailtable", "order": 13, "size": false, "presion": false, "verno": 2, "defval": "", "dtype": "Date", "required": false },
            { "name": "JSON-Single", "code": "json-single", "order": 14, "size": true, "presion": false, "verno": 2, "defval": "", "dtype": "JSON", "required": true },
            { "name": "JSON-Multiple", "code": "json-multiple", "order": 15, "size": true, "presion": false, "verno": 2, "defval": "", "dtype": "JSON", "required": true },
            { "name": "Number", "code": "number", "order": 16, "size": true, "presion": true, "verno": 2, "defval": "", "dtype": "Number", "required": true },
            { "name": "Text", "code": "text", "order": 17, "size": true, "presion": false, "verno": 2, "defval": "", "dtype": "String", "required": true },
            { "name": "Text - unicode", "code": "text-unicode", "order": 18, "size": true, "presion": false, "verno": 2, "defval": "", "dtype": "String", "required": true },
            { "name": "Boolean", "code": "boolean", "order": 19, "size": false, "presion": false, "verno": 2, "defval": "", "dtype": "Number", "required": false },
            { "name": "Time", "code": "time", "order": 20, "size": false, "presion": false, "verno": 2, "defval": "", "dtype": "Date Time", "required": false },
            { "name": "Datetime with time zone", "code": "datetimetz", "order": 21, "size": false, "presion": false, "verno": 2, "defval": "", "dtype": "Date Time", "required": false },
            { "name": "Timestamp", "code": "timestamp", "order": 22, "size": false, "presion": false, "verno": 2, "defval": "", "dtype": "Date Time", "required": false }
        ]
        if (loFlterdVal.length > 0) {
            loFinalResult = loglbjsonData.filter(field => loFlterdVal.some(obj => obj === String(field.verno)));
        } else {
            loFinalResult = loglbjsonData;
        }
        loFinalResult = loFinalResult.sort((a, b) => a.order - b.order);
        return loFinalResult;
    }
    catch (err) {
        console.log("Set Global DataType", err);
        return "";
    }
}
export async function glbLoadGlobalThemeData() {
    let loFinalArray = [];
    let loControlThemeData = await CallApi({ method: "get", lookup: "dpcrud/rt", params: { id: 3000088, ver: -1, alias: "-1", lparams: {} }, toa: "u" });
    let loThemeData = await CallApi({ method: "get", lookup: "dpcrud/rt", params: { id: 3000088, ver: -1, alias: "-1", lparams: {} }, toa: "o" });
    if (loControlThemeData.status === true) {
        if (loControlThemeData.data !== null && loControlThemeData.data.length > 0) {
            loFinalArray = loControlThemeData.data;
        }
    }
    if (loThemeData.status === true) {
        if (loThemeData.data !== null && loThemeData.data.length > 0) {
            let loTenantDb = loThemeData.data;
            loFinalArray = loFinalArray.concat(loTenantDb);
        }
    }
    refGlobalThemeJSON = loFinalArray;
    return loFinalArray;
}
export async function glbDecimalPlaces(pnnum, pndecimal) {
    let a = pnnum;
    let a1 = a.toString().split(".")[0];
    let a2 = a.toString().split(".").length > 1 ? "." + a.toString().split(".")[1].slice(0, pndecimal) : '';
    return Number(a1 + a2);
}
export const glbValidSpecificSplCharacters = (psvalue) => {
    let loAllowedSpecial = ['(', ')', '/', '\\', '-', '_', '@', '&', '.'];
    const escaped = loAllowedSpecial.map(ch => ch.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&')).join('');
    const regex = new RegExp(`^[a-zA-Z0-9${escaped}\\s]+$`);
    if (!regex.test(psvalue)) {
        return true;
    }
    return false;
}
export function glbPostMessage(loparams) {
    loparams.type = "FROM_TARGET_APPLICATION";
    window.parent.postMessage(
        loparams,
        "*" // or specify origin
    );
}
export async function glbGetLogoBase64(pstype) {
    let lofile = document.getElementById("divfilecompanylogo");
    if (lofile) {
        let lsbase64 = "";
        await fetch(lofile.src)
            .then(response => response.arrayBuffer())
            .then(buffer => {
                const base64String = btoa(
                    new Uint8Array(buffer)
                        .reduce((data, byte) =>
                            data + String.fromCharCode(byte), '')
                );
                lsbase64 = "data:image/jpeg;base64," + base64String;
            });
        return await lsbase64;
    }
}
export async function glbViewDisabledControl(podiv, psprops) {
    if (podiv && psprops) {
        if ((psprops.labelonvisible === true || psprops.labelonvisiable === true) && psprops.disabled === true) {
            podiv.classList.add("e-view-disabled");
        }
        else {
            podiv.classList.remove("e-view-disabled");
        }
    }
}
export async function glbBluetoothPrint(psmessage, pstype, poitem, pssize) {
    try {
        // const data = new TextEncoder().encode(psmessage);
        // window.SterloDefaultPrinter.characteristic.writeValue(data);  
        psmessage = psmessage + '\n\n';
        let loresponse = await printerService.print(psmessage, pstype, poitem, pssize);
        if (loresponse && loresponse.status == false) {
            showAlert(loresponse.errmsg, 'info');
        }
        else if (loresponse.status === true) {
            showAlert(loresponse.errmsg, 'success');
        }
    }
    catch (err) {
        console.log(err);
        showAlert(err, 'info');
    }
}
export const glbNavigateTo = (page, onClose) => {
    if (onClose && typeof onClose === 'function') {
        onClose(page);
    }
}
export async function glbUpdateTokenInfo(lofiltertoken) {
    // l = { "type": "", "tokenno": "", "tokenid": "", "displayuserid": "", "counterid": "", "countername": "", "servicelocation": "", "voicecount": "", "multicounter": {} }
    if (typeof lofiltertoken === "object") {
        let pscalltype = lofiltertoken.type;
        let pndispusid = lofiltertoken.displayuserid;
        let pomulticounterdata = lofiltertoken.multicounter;
        let pstokentype = lofiltertoken.tokentype;
        let psswapcounterid = lofiltertoken.swapcounterid;
        if (pndispusid > 0) {
            let loHeader = {
                "X-Content-Type-Options": "nosniff",
                "X-Frame-Options": "deny",
                "Content-Security-Policy": "script-src 'self'; style-src 'self'; ...",
                "Strict-Transport-Security": "max-age=63072000; includeSubDomains",
                "Content-Type": "application/json",
            };
            let lsmessage = lofiltertoken.tokenno;
            let lsreadmessage = lsmessage.split("").join(" ").replaceAll("0", " zero");
            lsreadmessage = "Token Number " + lsreadmessage + " in " + lofiltertoken.countername;
            let loconfig = glbGetLocalStorage("config");
            let lsCheckURL = loconfig.notificationurl + "api/v1/Signal/SendUser";
            let lomessage = { "type": "queuerefresh", "srcinfo": { "srcdoctyp": "2280078", "qctrlid": "3", servicelocation: lofiltertoken.servicelocation, counterid: lofiltertoken.counterid, tokenid: lofiltertoken.tokenid, counter: lofiltertoken.countername, voicecount: lofiltertoken.voicecount, tokentype: pstokentype, swapcounterid: psswapcounterid }, "message": lsmessage, "readmessage": lsreadmessage };
            if (pscalltype === "close") {
                lomessage.type = "closetoken";
                if (typeof pomulticounterdata === "object" && pomulticounterdata !== null && pomulticounterdata.multicounteraddtoken) {
                    lomessage.type = "multicounteraddtoken";
                    let poResponse = pomulticounterdata.responsedata;
                    if (typeof poResponse === "object" && poResponse !== null && poResponse.length > 0 && typeof poResponse[0].insjson === "string" && poResponse[0].insjson.includes("{") && poResponse[0].insjson.includes("}")) {
                        let loinsjson = JSON.parse(poResponse[0].insjson);
                        lomessage.counterinfo = loinsjson;
                    }
                }
            }
            else if (pscalltype === "add") {
                lomessage.type = "addtoken";
            }
            else if (pscalltype === "swap") {
                lomessage.type = "swaptoken";
            }
            let lobody = {
                "userid": pndispusid,
                // "group": "1:4038",
                "message": JSON.stringify(lomessage)
            };
            axios.post(lsCheckURL, lobody, { headers: loHeader }, { timeout: 900 }).then((response) => {
                if (response.status == 200) {
                    // console.log(response.data);
                } else {
                    console.log("Notification Send Failed, Status: " + response.status);
                }
            }).catch((err) => console.log("Notification Send Failed " + err.toString()));
        }
        else {
            showAlert("Display User Info not defined", 'info');
        }
    }
}
export async function glbExportHTMLToExcel(pstableid, psfilename, pssheetname) {
    const table = document.getElementById(pstableid);
    if (!table) return;

    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet(pssheetname || "QC Report");

    // ── Step 1: build a full 2-D grid honouring colspan and rowspan ─────────────
    // grid["r,c"]    = { value, rowClass, cellClass, rowspan, colspan }
    // occupied["r,c"] = true  →  position is covered by a span from another cell
    const numRows = table.rows.length;
    const grid = {};
    const occupied = {};
    let maxCols = 0;

    for (let r = 0; r < numRows; r++) {
        const htmlRow = table.rows[r];
        let c = 0;
        for (let ci = 0; ci < htmlRow.cells.length; ci++) {
            // advance past positions already covered by a rowspan from a previous row
            while (occupied[`${r},${c}`]) c++;
            const cell = htmlRow.cells[ci];
            const rs = cell.rowSpan || 1;
            const cs = cell.colSpan || 1;
            grid[`${r},${c}`] = {
                value: cell.innerText.trim(),
                rowClass: htmlRow.className,
                cellClass: cell.className,
                rowspan: rs,
                colspan: cs,
            };
            // mark every position covered by this span as occupied
            for (let dr = 0; dr < rs; dr++) {
                for (let dc = 0; dc < cs; dc++) {
                    if (dr || dc) occupied[`${r + dr},${c + dc}`] = true;
                }
            }
            c += cs;
            if (c > maxCols) maxCols = c;
        }
    }

    // Detect whether the table uses a 3-column date header (Date/Shift/Time) or 2-column
    const hasShiftCol = !!table.querySelector(".td-shift");
    const frozenCols = hasShiftCol ? 3 : 2;

    // ── Step 2: write cells to Excel, apply merges and styles ───────────────────
    for (let r = 0; r < numRows; r++) {
        worksheet.getRow(r + 1).height = r < 4 ? 20 : 16;

        for (let c = 0; c < maxCols; c++) {
            if (occupied[`${r},${c}`]) continue;   // covered by another cell's span
            const info = grid[`${r},${c}`];
            if (!info) continue;

            // merge before writing (ExcelJS keeps the top-left cell's value/style)
            if (info.rowspan > 1 || info.colspan > 1) {
                worksheet.mergeCells(r + 1, c + 1, r + info.rowspan, c + info.colspan);
            }

            const xCell = worksheet.getCell(r + 1, c + 1);

            // keep purely numeric cells as numbers so Excel can use them in formulas
            const isPureNumber = info.value !== "" && /^-?\d+(\.\d+)?$/.test(info.value);
            xCell.value = isPureNumber ? parseFloat(info.value) : info.value;

            // ── base style ────────────────────────────────────────────────────────
            xCell.border = {
                top: { style: "thin" },
                left: { style: "thin" },
                bottom: { style: "thin" },
                right: { style: "thin" },
            };
            xCell.alignment = { vertical: "middle", horizontal: "center", wrapText: true };
            xCell.font = { size: 10, name: "Calibri" };

            const rc = info.rowClass;
            const cc = info.cellClass;
            const isHeaderRow = rc.includes("th-");

            // ── row-level fill / font ─────────────────────────────────────────────
            if (rc.includes("th-group")) {
                xCell.fill = { type: "pattern", pattern: "solid", fgColor: { argb: "0F2B5E" } };
                xCell.font = { bold: true, size: 9, name: "Calibri", color: { argb: "FFFFFF" } };
            } else if (rc.includes("th-names")) {
                xCell.fill = { type: "pattern", pattern: "solid", fgColor: { argb: "192F5C" } };
                xCell.font = { bold: true, size: 10, name: "Calibri", color: { argb: "FFFFFF" } };
            } else if (rc.includes("th-mean")) {
                xCell.fill = { type: "pattern", pattern: "solid", fgColor: { argb: "EEF4FF" } };
                xCell.font = { bold: true, size: 10, name: "Calibri", color: { argb: "1A3A8A" } };
            } else if (rc.includes("th-range")) {
                xCell.fill = { type: "pattern", pattern: "solid", fgColor: { argb: "FFF7E6" } };
                xCell.font = { bold: true, size: 10, name: "Calibri", color: { argb: "7C3400" } };
            }

            // ── cell-class overrides ──────────────────────────────────────────────
            if (cc.includes("td-date") || cc.includes("td-date-l2")) {
                xCell.alignment = { vertical: "middle", horizontal: "left", wrapText: true };
                if (!isHeaderRow) {
                    xCell.fill = { type: "pattern", pattern: "solid", fgColor: { argb: "F8F9FB" } };
                    xCell.font = { bold: true, size: 10, name: "Calibri" };
                }
            }
            if (cc.includes("td-shift")) {
                xCell.alignment = { vertical: "middle", horizontal: "left", wrapText: true };
                if (!isHeaderRow) {
                    xCell.fill = { type: "pattern", pattern: "solid", fgColor: { argb: "F8F9FB" } };
                    xCell.font = { bold: true, size: 9, name: "Calibri" };
                }
            }
            if (cc.includes("td-time")) {
                xCell.alignment = { vertical: "middle", horizontal: "left", wrapText: true };
                if (!isHeaderRow) {
                    xCell.fill = { type: "pattern", pattern: "solid", fgColor: { argb: "F8F9FB" } };
                    xCell.font = { italic: true, size: 9, name: "Calibri", color: { argb: "9BA3B2" } };
                }
            }
            if (cc.includes("sig")) {
                xCell.fill = { type: "pattern", pattern: "solid", fgColor: { argb: "FAFBFF" } };
                xCell.font = { size: 9, name: "Calibri", color: { argb: "5A6071" } };
            }
            // OOR: overrides every other style set above
            if (cc.includes("oor")) {
                xCell.fill = { type: "pattern", pattern: "solid", fgColor: { argb: "FDE8E7" } };
                xCell.font = { bold: true, size: 10, name: "Calibri", color: { argb: "C0392B" } };
            }

            // Day-group separator: thick top border on first row of each date block
            if (rc.includes("day-first")) {
                xCell.border = { ...xCell.border, top: { style: "medium", color: { argb: "CBD0D8" } } };
            }
        }
    }

    // ── Step 3: column widths ────────────────────────────────────────────────────
    worksheet.getColumn(1).width = 10;                                  // Date
    worksheet.getColumn(2).width = hasShiftCol ? 12 : 9;               // Shift | Time
    if (hasShiftCol) worksheet.getColumn(3).width = 9;                  // Time (L1 only)
    for (let c = frozenCols + 1; c <= maxCols - 3; c++) {
        worksheet.getColumn(c).width = 12;                              // data columns
    }
    for (let c = maxCols - 2; c <= maxCols; c++) {
        worksheet.getColumn(c).width = 14;                              // auth columns
    }

    // ── Step 4: freeze header rows + date/shift columns ─────────────────────────
    worksheet.views = [{ state: "frozen", xSplit: frozenCols, ySplit: 4 }];

    // ── Step 5: save ─────────────────────────────────────────────────────────────
    const buffer = await workbook.xlsx.writeBuffer();
    saveAs(new Blob([buffer]), (psfilename || "QC_Report") + ".xlsx");
}
export function glbApplicableControls() {//Loading completed verify logic
    return [
        { ctrlcode: "WFC013", ctrlname: "SterDropDown", type: "all" },
        { ctrlcode: "WFC050", ctrlname: "SterMultiDropdown", type: "all" },
        { ctrlcode: "WFC021", ctrlname: "SterDate", type: "all" },
        { ctrlcode: "WFC022", ctrlname: "SterDateTime", type: "all" },
        { ctrlcode: "WFC098", ctrlname: "sterdaterange", type: "all" },
        { ctrlcode: "WFC011", ctrlname: "SterInputText", type: "all" },
        { ctrlcode: "WFC023", ctrlname: "SterInputNumber", type: "all" },
        { ctrlcode: "WFC016", ctrlname: "SterImage", type: "all" },
        { ctrlcode: "WFC026", ctrlname: "SterDataTable", type: "all" },
        { ctrlcode: "WFC019", ctrlname: "SterSwitchButton", type: "all" },
        { ctrlcode: "WFC070", ctrlname: "SterRating", type: "all" },
        { ctrlcode: "WFC056", ctrlname: "SterTemplates", type: "all" },
        { ctrlcode: "WDC027", ctrlname: "SterDataView", type: "loading" },
        { ctrlcode: "WFC017", ctrlname: "SterFileUpload", type: "loading" },
        { ctrlcode: "WFC014", ctrlname: "SterRadioButton", type: "closeconfirm" },
        { ctrlcode: "WFC012", ctrlname: "SterCheckBox", type: "closeconfirm" },
        { ctrlcode: "WFC058", ctrlname: "SterTextTree", type: "closeconfirm" },
        { ctrlcode: "WFC108", ctrlname: "SterUserCtrl", type: "closeconfirm" },
    ]
}
function fnIfCondition(value) {
    if (value !== undefined && value !== null && value !== "") {
        return true;
    }
}
export function glbCssRender(value, lsrefScreenid) {
    // let parseCss = require('css');
    let CssObj;
    let csstags;
    csstags = document.head.querySelectorAll("style");
    if (fnIfCondition(csstags) && csstags.length > 0) {
        csstags.forEach((singleCssTags) => {
            if (singleCssTags.getAttribute('name') === String(lsrefScreenid)) {
                singleCssTags.parentNode.removeChild(singleCssTags);
            }
        })
    }
    try {
        if (fnIfCondition(value)) {
            CssObj = parse(value);
            if (CssObj.stylesheet !== undefined) {
                if (CssObj.stylesheet.rules.length > 0) {
                    CssObj.stylesheet.rules.forEach((item) => {
                        if (item.type === "rule") {
                            item.selectors[0] = "#HtmlRenderPart_" + lsrefScreenid + " " + item.selectors[0]
                        } else if (item.type === "media") {
                            item.rules.forEach((mitem) => {
                                mitem.selectors[0] = "#HtmlRenderPart_" + lsrefScreenid + " " + mitem.selectors[0]
                            })
                        }
                    })
                }
            }
            let CssTag = document.createElement("style");
            CssTag.textContent = CssObj !== undefined ? stringify(CssObj) : ""
            CssTag.setAttribute('name', lsrefScreenid);
            document.head.appendChild(CssTag);
        }
    } catch (e) { }
}
//Wizard - Page Setting Save Mapping Property target-update design/canvas/table;getval-To get value;saveval - JSON array design7/design&canvas update
export const glbWizardMappingJSON = [{ "ordno": 1, "refname": "refObjName", "caption": "Name", "fldnm": "dname", "parent": "geninfo", "saveval": "desgnlib", "getval": "value", "refno": 3, "target": "design" },
{ "ordno": 2, "refname": "refObjDesc", "caption": "Discription", "fldnm": "ddesc", "parent": "geninfo", "saveval": "desgnlib", "getval": "value", "refno": 5, "target": "design" },
{ "ordno": 3, "refname": "refCrudTbleObj", "caption": "Dataset", "fldnm": "dsetref", "parent": "geninfo", "saveval": "desgnlib", "getval": "value", "refno": 7, "target": "design" },
{ "ordno": 4, "refname": "refDocPrintOpt", "caption": "Document Print", "fldnm": "docprint", "parent": "docprint", "saveval": "desgnlib", "getval": "checked", "refno": 15, "target": "canvas" },
{ "ordno": 5, "refname": "refDocType", "caption": "Print Type", "fldnm": "ptype", "parent": "docprint", "saveval": "desgnlib", "getval": "value", "refno": 10, "target": "canvas" },
{ "ordno": 6, "refname": "refLinkPrint", "caption": "Link Print ", "fldnm": "linkdocument", "parent": "docprint", "saveval": "desgnlib", "getval": "value", "refno": 11, "target": "canvas" },
{ "ordno": 7, "refname": "refSearchOpt", "caption": "Search Applicable", "fldnm": "searchoption", "parent": "searchds", "saveval": "desgnlib", "getval": "checked", "refno": 14, "target": "canvas" },
{ "ordno": 8, "refname": "refSearchDataSrc", "caption": "Search DataSource ", "fldnm": "searchdatasource", "parent": "searchds", "saveval": "desgnlib", "getval": "value", "refno": 18, "target": "canvas" },
{ "ordno": 9, "refname": "refLinkTemplate", "caption": "Link Template", "fldnm": "tempdet", "parent": "linktemp", "saveval": "design7", "getval": "value", "refno": 12, "target": "table" },
{ "ordno": 10, "refname": "refUserRights", "caption": "User Grid ", "fldnm": "rightdet", "parent": "usrrights", "saveval": "design7", "getval": "dataSource", "refno": 16, "target": "table" },
{ "ordno": 11, "refname": "refMultipleDataSrcGrid", "caption": "DataSource Grid ", "fldnm": "flddsrc", "parent": "datasrc", "saveval": "design7", "getval": "dataSource", "refno": 17, "target": "table" },
{ "ordno": 12, "refname": "refCrudPgeOpt", "caption": "CRUD Datasource", "fldnm": "crudds", "parent": "geninfo", "saveval": "desgnlib", "getval": "value", "refno": 20, "target": "design" }]